import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Date: { input: string; output: string; }
  JSONObject: { input: any; output: any; }
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve a single "Block" node. */
  block?: Maybe<Block>;
  /** Retrieve the number of "Block" nodes. */
  blockCount: Scalars['Int']['output'];
  /** Retrieve a list of "Block" nodes. */
  blocks: Array<Block>;
  /** Retrieve a single "Campaign" node. */
  campaign?: Maybe<Campaign>;
  /** Retrieve the number of "Campaign" nodes. */
  campaignCount: Scalars['Int']['output'];
  /** Retrieve a list of "CampaignHistory" nodes. */
  campaignHistories: Array<CampaignHistory>;
  /** Retrieve a single "CampaignHistory" node. */
  campaignHistory?: Maybe<CampaignHistory>;
  /** Retrieve the number of "CampaignHistory" nodes. */
  campaignHistoryCount: Scalars['Int']['output'];
  /** Retrieve a list of "Campaign" nodes. */
  campaigns: Array<Campaign>;
  /** Retrieve a list of "FlashSenderHistory" nodes. */
  flashSenderHistories: Array<FlashSenderHistory>;
  /** Retrieve a single "FlashSenderHistory" node. */
  flashSenderHistory?: Maybe<FlashSenderHistory>;
  /** Retrieve the number of "FlashSenderHistory" nodes. */
  flashSenderHistoryCount: Scalars['Int']['output'];
  /** List allowed brandKeys */
  getBrandKeys: Array<BrandKey>;
  /** List available newsletter from NlFactory */
  getNewsletterByName?: Maybe<NewsletterNlf>;
  /** List available newsletter from NlFactory */
  getNewslettersByBrandKey: Array<Maybe<NewsletterNlf>>;
  /** Returns a suggestion from GPT-4 */
  getSuggestionOpenAi?: Maybe<Scalars['String']['output']>;
  /** List GA top resources */
  getTopRessources4?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieve a single "Newsletter" node. */
  newsletter?: Maybe<Newsletter>;
  /** Retrieve the number of "Newsletter" nodes. */
  newsletterCount: Scalars['Int']['output'];
  /** Retrieve a single "NewsletterDuplication" node. */
  newsletterDuplication?: Maybe<NewsletterDuplication>;
  /** Retrieve the number of "NewsletterDuplication" nodes. */
  newsletterDuplicationCount: Scalars['Int']['output'];
  /** Retrieve a list of "NewsletterDuplication" nodes. */
  newsletterDuplications: Array<NewsletterDuplication>;
  /** Retrieve a single "NewsletterGeneration" node. */
  newsletterGeneration?: Maybe<NewsletterGeneration>;
  /** Retrieve the number of "NewsletterGeneration" nodes. */
  newsletterGenerationCount: Scalars['Int']['output'];
  /** Retrieve a list of "NewsletterGeneration" nodes. */
  newsletterGenerations: Array<NewsletterGeneration>;
  /** Retrieve a list of "NewsletterHistory" nodes. */
  newsletterHistories: Array<NewsletterHistory>;
  /** Retrieve a single "NewsletterHistory" node. */
  newsletterHistory?: Maybe<NewsletterHistory>;
  /** Retrieve the number of "NewsletterHistory" nodes. */
  newsletterHistoryCount: Scalars['Int']['output'];
  /** Retrieve a list of "Newsletter" nodes. */
  newsletters: Array<Newsletter>;
  /** Retrieve a single "Section" node. */
  section?: Maybe<Section>;
  /** Retrieve the number of "Section" nodes. */
  sectionCount: Scalars['Int']['output'];
  /** Retrieve a list of "Section" nodes. */
  sections: Array<Section>;
};


export type QueryBlockArgs = {
  where: BlockWhereUniqueInput;
};


export type QueryBlockCountArgs = {
  where?: InputMaybe<BlockWhereInput>;
};


export type QueryBlocksArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<BlockOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlockWhereInput>;
};


export type QueryCampaignArgs = {
  where: CampaignWhereUniqueInput;
};


export type QueryCampaignCountArgs = {
  where?: InputMaybe<CampaignWhereInput>;
};


export type QueryCampaignHistoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CampaignHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CampaignHistoryWhereInput>;
};


export type QueryCampaignHistoryArgs = {
  where: CampaignHistoryWhereUniqueInput;
};


export type QueryCampaignHistoryCountArgs = {
  where?: InputMaybe<CampaignHistoryWhereInput>;
};


export type QueryCampaignsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CampaignOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CampaignWhereInput>;
};


export type QueryFlashSenderHistoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<FlashSenderHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FlashSenderHistoryWhereInput>;
};


export type QueryFlashSenderHistoryArgs = {
  where: FlashSenderHistoryWhereUniqueInput;
};


export type QueryFlashSenderHistoryCountArgs = {
  where?: InputMaybe<FlashSenderHistoryWhereInput>;
};


export type QueryGetNewsletterByNameArgs = {
  brandKey: BrandKey;
  name: Scalars['String']['input'];
};


export type QueryGetNewslettersByBrandKeyArgs = {
  brandKey: BrandKey;
};


export type QueryGetSuggestionOpenAiArgs = {
  prompt: Scalars['String']['input'];
};


export type QueryGetTopRessources4Args = {
  brandKey: BrandKey;
  dayRange: Scalars['Int']['input'];
  ressource: ContentType;
};


export type QueryNewsletterArgs = {
  where: NewsletterWhereUniqueInput;
};


export type QueryNewsletterCountArgs = {
  where?: InputMaybe<NewsletterWhereInput>;
};


export type QueryNewsletterDuplicationArgs = {
  where: NewsletterDuplicationWhereUniqueInput;
};


export type QueryNewsletterDuplicationCountArgs = {
  where?: InputMaybe<NewsletterDuplicationWhereInput>;
};


export type QueryNewsletterDuplicationsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<NewsletterDuplicationOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NewsletterDuplicationWhereInput>;
};


export type QueryNewsletterGenerationArgs = {
  where: NewsletterGenerationWhereUniqueInput;
};


export type QueryNewsletterGenerationCountArgs = {
  where?: InputMaybe<NewsletterGenerationWhereInput>;
};


export type QueryNewsletterGenerationsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<NewsletterGenerationOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NewsletterGenerationWhereInput>;
};


export type QueryNewsletterHistoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<NewsletterHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NewsletterHistoryWhereInput>;
};


export type QueryNewsletterHistoryArgs = {
  where: NewsletterHistoryWhereUniqueInput;
};


export type QueryNewsletterHistoryCountArgs = {
  where?: InputMaybe<NewsletterHistoryWhereInput>;
};


export type QueryNewslettersArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<NewsletterOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NewsletterWhereInput>;
};


export type QuerySectionArgs = {
  where: SectionWhereUniqueInput;
};


export type QuerySectionCountArgs = {
  where?: InputMaybe<SectionWhereInput>;
};


export type QuerySectionsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<SectionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SectionWhereInput>;
};

/**
 * Identifies exactly one "Block" node with one of these unique values:
 * - _id
 * - id
 */
export type BlockWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** "Block" resource's node */
export type Block = {
  __typename?: 'Block';
  /** The article ID */
  articleId?: Maybe<Scalars['ID']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['ID']['output'];
  /** Is the block automated */
  isAutomated?: Maybe<Scalars['Boolean']['output']>;
  isAutoPromo?: Maybe<Scalars['Boolean']['output']>;
  leadIn?: Maybe<Scalars['Boolean']['output']>;
  linkLabel?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Media>;
  position?: Maybe<Scalars['Int']['output']>;
  rawMedia?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Section>;
  surTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Media = {
  __typename?: 'Media';
  caption?: Maybe<Scalars['String']['output']>;
  focusPoint?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  iframely?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** "Section" resource's node */
export type Section = {
  __typename?: 'Section';
  /** "Block.section"'s inverse relation count */
  blockCount: Scalars['Int']['output'];
  /** "Block.section"'s inverse relation */
  blocks: Array<Block>;
  campaign: Campaign;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['ID']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


/** "Section" resource's node */
export type SectionBlockCountArgs = {
  where?: InputMaybe<BlockWhereInput>;
};


/** "Section" resource's node */
export type SectionBlocksArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<BlockOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlockWhereInput>;
};

/** Filters the "Block" nodes by specifying some conditions */
export type BlockWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<BlockWhereInput>>;
  articleId?: InputMaybe<Scalars['ID']['input']>;
  articleId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  articleId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  articleId_not?: InputMaybe<Scalars['ID']['input']>;
  articleId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  blockType?: InputMaybe<Scalars['String']['input']>;
  blockType_contains?: InputMaybe<Scalars['String']['input']>;
  blockType_ends_with?: InputMaybe<Scalars['String']['input']>;
  blockType_gt?: InputMaybe<Scalars['String']['input']>;
  blockType_gte?: InputMaybe<Scalars['String']['input']>;
  blockType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blockType_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  blockType_lt?: InputMaybe<Scalars['String']['input']>;
  blockType_lte?: InputMaybe<Scalars['String']['input']>;
  blockType_not?: InputMaybe<Scalars['String']['input']>;
  blockType_not_contains?: InputMaybe<Scalars['String']['input']>;
  blockType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  blockType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blockType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  blockType_starts_with?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_gt?: InputMaybe<Scalars['String']['input']>;
  body_gte?: InputMaybe<Scalars['String']['input']>;
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  body_lt?: InputMaybe<Scalars['String']['input']>;
  body_lte?: InputMaybe<Scalars['String']['input']>;
  body_not?: InputMaybe<Scalars['String']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  content_gt?: InputMaybe<Scalars['String']['input']>;
  content_gte?: InputMaybe<Scalars['String']['input']>;
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  content_lt?: InputMaybe<Scalars['String']['input']>;
  content_lte?: InputMaybe<Scalars['String']['input']>;
  content_not?: InputMaybe<Scalars['String']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isAutomated?: InputMaybe<Scalars['Boolean']['input']>;
  isAutomated_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isAutomated_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  isAutomated_not?: InputMaybe<Scalars['Boolean']['input']>;
  isAutomated_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isAutoPromo?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoPromo_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isAutoPromo_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoPromo_not?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoPromo_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  leadIn?: InputMaybe<Scalars['Boolean']['input']>;
  leadIn_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  leadIn_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  leadIn_not?: InputMaybe<Scalars['Boolean']['input']>;
  leadIn_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  linkLabel?: InputMaybe<Scalars['String']['input']>;
  linkLabel_contains?: InputMaybe<Scalars['String']['input']>;
  linkLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  linkLabel_gt?: InputMaybe<Scalars['String']['input']>;
  linkLabel_gte?: InputMaybe<Scalars['String']['input']>;
  linkLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkLabel_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  linkLabel_lt?: InputMaybe<Scalars['String']['input']>;
  linkLabel_lte?: InputMaybe<Scalars['String']['input']>;
  linkLabel_not?: InputMaybe<Scalars['String']['input']>;
  linkLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  linkLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  linkLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<BlockWhereInput>;
  OR?: InputMaybe<Array<BlockWhereInput>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  position_gt?: InputMaybe<Scalars['Int']['input']>;
  position_gte?: InputMaybe<Scalars['Int']['input']>;
  position_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  position_lt?: InputMaybe<Scalars['Int']['input']>;
  position_lte?: InputMaybe<Scalars['Int']['input']>;
  position_not?: InputMaybe<Scalars['Int']['input']>;
  position_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rawMedia?: InputMaybe<Scalars['String']['input']>;
  rawMedia_contains?: InputMaybe<Scalars['String']['input']>;
  rawMedia_ends_with?: InputMaybe<Scalars['String']['input']>;
  rawMedia_gt?: InputMaybe<Scalars['String']['input']>;
  rawMedia_gte?: InputMaybe<Scalars['String']['input']>;
  rawMedia_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rawMedia_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  rawMedia_lt?: InputMaybe<Scalars['String']['input']>;
  rawMedia_lte?: InputMaybe<Scalars['String']['input']>;
  rawMedia_not?: InputMaybe<Scalars['String']['input']>;
  rawMedia_not_contains?: InputMaybe<Scalars['String']['input']>;
  rawMedia_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  rawMedia_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rawMedia_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  rawMedia_starts_with?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<SectionWhereInput>;
  section_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  surTitle?: InputMaybe<Scalars['String']['input']>;
  surTitle_contains?: InputMaybe<Scalars['String']['input']>;
  surTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  surTitle_gt?: InputMaybe<Scalars['String']['input']>;
  surTitle_gte?: InputMaybe<Scalars['String']['input']>;
  surTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surTitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  surTitle_lt?: InputMaybe<Scalars['String']['input']>;
  surTitle_lte?: InputMaybe<Scalars['String']['input']>;
  surTitle_not?: InputMaybe<Scalars['String']['input']>;
  surTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  surTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  surTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  surTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  url_gt?: InputMaybe<Scalars['String']['input']>;
  url_gte?: InputMaybe<Scalars['String']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  url_lt?: InputMaybe<Scalars['String']['input']>;
  url_lte?: InputMaybe<Scalars['String']['input']>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "Section" nodes by specifying some conditions */
export type SectionWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<SectionWhereInput>>;
  blocks_some?: InputMaybe<BlockWhereInput>;
  campaign?: InputMaybe<CampaignWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  NOT?: InputMaybe<SectionWhereInput>;
  OR?: InputMaybe<Array<SectionWhereInput>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  position_gt?: InputMaybe<Scalars['Int']['input']>;
  position_gte?: InputMaybe<Scalars['Int']['input']>;
  position_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  position_lt?: InputMaybe<Scalars['Int']['input']>;
  position_lte?: InputMaybe<Scalars['Int']['input']>;
  position_not?: InputMaybe<Scalars['Int']['input']>;
  position_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  url_gt?: InputMaybe<Scalars['String']['input']>;
  url_gte?: InputMaybe<Scalars['String']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  url_lt?: InputMaybe<Scalars['String']['input']>;
  url_lte?: InputMaybe<Scalars['String']['input']>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "Campaign" nodes by specifying some conditions */
export type CampaignWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<CampaignWhereInput>>;
  availableAt?: InputMaybe<Scalars['Date']['input']>;
  availableAt_gt?: InputMaybe<Scalars['Date']['input']>;
  availableAt_gte?: InputMaybe<Scalars['Date']['input']>;
  availableAt_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  availableAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  availableAt_lt?: InputMaybe<Scalars['Date']['input']>;
  availableAt_lte?: InputMaybe<Scalars['Date']['input']>;
  availableAt_not?: InputMaybe<Scalars['Date']['input']>;
  availableAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  campaignHistories_some?: InputMaybe<CampaignHistoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lockedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lockedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lockedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
  lockerId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lockerId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lockerId_not?: InputMaybe<Scalars['ID']['input']>;
  lockerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  newsletter?: InputMaybe<NewsletterWhereInput>;
  newsletter_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<CampaignWhereInput>;
  OR?: InputMaybe<Array<CampaignWhereInput>>;
  preHeader?: InputMaybe<Scalars['String']['input']>;
  preHeader_contains?: InputMaybe<Scalars['String']['input']>;
  preHeader_ends_with?: InputMaybe<Scalars['String']['input']>;
  preHeader_gt?: InputMaybe<Scalars['String']['input']>;
  preHeader_gte?: InputMaybe<Scalars['String']['input']>;
  preHeader_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preHeader_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  preHeader_lt?: InputMaybe<Scalars['String']['input']>;
  preHeader_lte?: InputMaybe<Scalars['String']['input']>;
  preHeader_not?: InputMaybe<Scalars['String']['input']>;
  preHeader_not_contains?: InputMaybe<Scalars['String']['input']>;
  preHeader_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  preHeader_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preHeader_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  preHeader_starts_with?: InputMaybe<Scalars['String']['input']>;
  rawMedias?: InputMaybe<Scalars['String']['input']>;
  rawMedias_contains?: InputMaybe<Scalars['String']['input']>;
  rawMedias_ends_with?: InputMaybe<Scalars['String']['input']>;
  rawMedias_gt?: InputMaybe<Scalars['String']['input']>;
  rawMedias_gte?: InputMaybe<Scalars['String']['input']>;
  rawMedias_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rawMedias_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  rawMedias_lt?: InputMaybe<Scalars['String']['input']>;
  rawMedias_lte?: InputMaybe<Scalars['String']['input']>;
  rawMedias_not?: InputMaybe<Scalars['String']['input']>;
  rawMedias_not_contains?: InputMaybe<Scalars['String']['input']>;
  rawMedias_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  rawMedias_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rawMedias_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  rawMedias_starts_with?: InputMaybe<Scalars['String']['input']>;
  sections_some?: InputMaybe<SectionWhereInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_contains?: InputMaybe<Scalars['String']['input']>;
  subject_ends_with?: InputMaybe<Scalars['String']['input']>;
  subject_gt?: InputMaybe<Scalars['String']['input']>;
  subject_gte?: InputMaybe<Scalars['String']['input']>;
  subject_in?: InputMaybe<Array<Scalars['String']['input']>>;
  subject_lt?: InputMaybe<Scalars['String']['input']>;
  subject_lte?: InputMaybe<Scalars['String']['input']>;
  subject_not?: InputMaybe<Scalars['String']['input']>;
  subject_not_contains?: InputMaybe<Scalars['String']['input']>;
  subject_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  subject_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  subject_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  subject_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  url_gt?: InputMaybe<Scalars['String']['input']>;
  url_gte?: InputMaybe<Scalars['String']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  url_lt?: InputMaybe<Scalars['String']['input']>;
  url_lte?: InputMaybe<Scalars['String']['input']>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmContent_contains?: InputMaybe<Scalars['String']['input']>;
  utmContent_ends_with?: InputMaybe<Scalars['String']['input']>;
  utmContent_gt?: InputMaybe<Scalars['String']['input']>;
  utmContent_gte?: InputMaybe<Scalars['String']['input']>;
  utmContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmContent_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  utmContent_lt?: InputMaybe<Scalars['String']['input']>;
  utmContent_lte?: InputMaybe<Scalars['String']['input']>;
  utmContent_not?: InputMaybe<Scalars['String']['input']>;
  utmContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  utmContent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  utmContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmContent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  utmContent_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "CampaignHistory" nodes by specifying some conditions */
export type CampaignHistoryWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<CampaignHistoryWhereInput>>;
  campaign?: InputMaybe<CampaignWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  NOT?: InputMaybe<CampaignHistoryWhereInput>;
  OR?: InputMaybe<Array<CampaignHistoryWhereInput>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_not?: InputMaybe<Scalars['ID']['input']>;
  userId_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  userName?: InputMaybe<Scalars['String']['input']>;
  userName_contains?: InputMaybe<Scalars['String']['input']>;
  userName_ends_with?: InputMaybe<Scalars['String']['input']>;
  userName_gt?: InputMaybe<Scalars['String']['input']>;
  userName_gte?: InputMaybe<Scalars['String']['input']>;
  userName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  userName_lt?: InputMaybe<Scalars['String']['input']>;
  userName_lte?: InputMaybe<Scalars['String']['input']>;
  userName_not?: InputMaybe<Scalars['String']['input']>;
  userName_not_contains?: InputMaybe<Scalars['String']['input']>;
  userName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  userName_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  userName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  userName_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "Newsletter" nodes by specifying some conditions */
export type NewsletterWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  aiDefaultPromptHeader?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptHeader_contains?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptHeader_ends_with?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptHeader_gt?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptHeader_gte?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptHeader_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiDefaultPromptHeader_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  aiDefaultPromptHeader_lt?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptHeader_lte?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptHeader_not?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptHeader_not_contains?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptHeader_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptHeader_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiDefaultPromptHeader_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptHeader_starts_with?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptObject?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptObject_contains?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptObject_ends_with?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptObject_gt?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptObject_gte?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptObject_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiDefaultPromptObject_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  aiDefaultPromptObject_lt?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptObject_lte?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptObject_not?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptObject_not_contains?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptObject_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptObject_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiDefaultPromptObject_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptObject_starts_with?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptHeader?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptHeader_contains?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptHeader_ends_with?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptHeader_gt?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptHeader_gte?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptHeader_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiUserPromptHeader_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  aiUserPromptHeader_lt?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptHeader_lte?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptHeader_not?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptHeader_not_contains?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptHeader_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptHeader_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiUserPromptHeader_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptHeader_starts_with?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptObject?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptObject_contains?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptObject_ends_with?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptObject_gt?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptObject_gte?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptObject_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiUserPromptObject_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  aiUserPromptObject_lt?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptObject_lte?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptObject_not?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptObject_not_contains?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptObject_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptObject_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiUserPromptObject_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptObject_starts_with?: InputMaybe<Scalars['String']['input']>;
  AND?: InputMaybe<Array<NewsletterWhereInput>>;
  automationConfig?: InputMaybe<Scalars['String']['input']>;
  automationConfig_contains?: InputMaybe<Scalars['String']['input']>;
  automationConfig_ends_with?: InputMaybe<Scalars['String']['input']>;
  automationConfig_gt?: InputMaybe<Scalars['String']['input']>;
  automationConfig_gte?: InputMaybe<Scalars['String']['input']>;
  automationConfig_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  automationConfig_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  automationConfig_lt?: InputMaybe<Scalars['String']['input']>;
  automationConfig_lte?: InputMaybe<Scalars['String']['input']>;
  automationConfig_not?: InputMaybe<Scalars['String']['input']>;
  automationConfig_not_contains?: InputMaybe<Scalars['String']['input']>;
  automationConfig_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  automationConfig_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  automationConfig_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  automationConfig_starts_with?: InputMaybe<Scalars['String']['input']>;
  automationQuery?: InputMaybe<Scalars['String']['input']>;
  automationQuery_contains?: InputMaybe<Scalars['String']['input']>;
  automationQuery_ends_with?: InputMaybe<Scalars['String']['input']>;
  automationQuery_gt?: InputMaybe<Scalars['String']['input']>;
  automationQuery_gte?: InputMaybe<Scalars['String']['input']>;
  automationQuery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  automationQuery_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  automationQuery_lt?: InputMaybe<Scalars['String']['input']>;
  automationQuery_lte?: InputMaybe<Scalars['String']['input']>;
  automationQuery_not?: InputMaybe<Scalars['String']['input']>;
  automationQuery_not_contains?: InputMaybe<Scalars['String']['input']>;
  automationQuery_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  automationQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  automationQuery_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  automationQuery_starts_with?: InputMaybe<Scalars['String']['input']>;
  automationTime?: InputMaybe<Scalars['Int']['input']>;
  automationTime_gt?: InputMaybe<Scalars['Int']['input']>;
  automationTime_gte?: InputMaybe<Scalars['Int']['input']>;
  automationTime_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  automationTime_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  automationTime_lt?: InputMaybe<Scalars['Int']['input']>;
  automationTime_lte?: InputMaybe<Scalars['Int']['input']>;
  automationTime_not?: InputMaybe<Scalars['Int']['input']>;
  automationTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  autoValidateXMLCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  autoValidateXMLCampaign_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  autoValidateXMLCampaign_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  autoValidateXMLCampaign_not?: InputMaybe<Scalars['Boolean']['input']>;
  autoValidateXMLCampaign_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  available?: InputMaybe<Scalars['String']['input']>;
  available_contains?: InputMaybe<Scalars['String']['input']>;
  available_ends_with?: InputMaybe<Scalars['String']['input']>;
  available_gt?: InputMaybe<Scalars['String']['input']>;
  available_gte?: InputMaybe<Scalars['String']['input']>;
  available_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  available_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  available_lt?: InputMaybe<Scalars['String']['input']>;
  available_lte?: InputMaybe<Scalars['String']['input']>;
  available_not?: InputMaybe<Scalars['String']['input']>;
  available_not_contains?: InputMaybe<Scalars['String']['input']>;
  available_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  available_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  available_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  available_starts_with?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  campaignPreHeaderPattern?: InputMaybe<Scalars['String']['input']>;
  campaignPreHeaderPattern_contains?: InputMaybe<Scalars['String']['input']>;
  campaignPreHeaderPattern_ends_with?: InputMaybe<Scalars['String']['input']>;
  campaignPreHeaderPattern_gt?: InputMaybe<Scalars['String']['input']>;
  campaignPreHeaderPattern_gte?: InputMaybe<Scalars['String']['input']>;
  campaignPreHeaderPattern_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  campaignPreHeaderPattern_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  campaignPreHeaderPattern_lt?: InputMaybe<Scalars['String']['input']>;
  campaignPreHeaderPattern_lte?: InputMaybe<Scalars['String']['input']>;
  campaignPreHeaderPattern_not?: InputMaybe<Scalars['String']['input']>;
  campaignPreHeaderPattern_not_contains?: InputMaybe<Scalars['String']['input']>;
  campaignPreHeaderPattern_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  campaignPreHeaderPattern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  campaignPreHeaderPattern_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  campaignPreHeaderPattern_starts_with?: InputMaybe<Scalars['String']['input']>;
  campaigns_some?: InputMaybe<CampaignWhereInput>;
  campaignSubjectPattern?: InputMaybe<Scalars['String']['input']>;
  campaignSubjectPattern_contains?: InputMaybe<Scalars['String']['input']>;
  campaignSubjectPattern_ends_with?: InputMaybe<Scalars['String']['input']>;
  campaignSubjectPattern_gt?: InputMaybe<Scalars['String']['input']>;
  campaignSubjectPattern_gte?: InputMaybe<Scalars['String']['input']>;
  campaignSubjectPattern_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  campaignSubjectPattern_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  campaignSubjectPattern_lt?: InputMaybe<Scalars['String']['input']>;
  campaignSubjectPattern_lte?: InputMaybe<Scalars['String']['input']>;
  campaignSubjectPattern_not?: InputMaybe<Scalars['String']['input']>;
  campaignSubjectPattern_not_contains?: InputMaybe<Scalars['String']['input']>;
  campaignSubjectPattern_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  campaignSubjectPattern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  campaignSubjectPattern_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  campaignSubjectPattern_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  defaultCampaignSectionCount?: InputMaybe<Scalars['Int']['input']>;
  defaultCampaignSectionCount_gt?: InputMaybe<Scalars['Int']['input']>;
  defaultCampaignSectionCount_gte?: InputMaybe<Scalars['Int']['input']>;
  defaultCampaignSectionCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  defaultCampaignSectionCount_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  defaultCampaignSectionCount_lt?: InputMaybe<Scalars['Int']['input']>;
  defaultCampaignSectionCount_lte?: InputMaybe<Scalars['Int']['input']>;
  defaultCampaignSectionCount_not?: InputMaybe<Scalars['Int']['input']>;
  defaultCampaignSectionCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  frequency_contains?: InputMaybe<Scalars['String']['input']>;
  frequency_ends_with?: InputMaybe<Scalars['String']['input']>;
  frequency_gt?: InputMaybe<Scalars['String']['input']>;
  frequency_gte?: InputMaybe<Scalars['String']['input']>;
  frequency_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  frequency_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  frequency_lt?: InputMaybe<Scalars['String']['input']>;
  frequency_lte?: InputMaybe<Scalars['String']['input']>;
  frequency_not?: InputMaybe<Scalars['String']['input']>;
  frequency_not_contains?: InputMaybe<Scalars['String']['input']>;
  frequency_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  frequency_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  frequency_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  frequency_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isFromNlf?: InputMaybe<Scalars['Boolean']['input']>;
  isFromNlf_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isFromNlf_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  isFromNlf_not?: InputMaybe<Scalars['Boolean']['input']>;
  isFromNlf_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  linkUrl_gt?: InputMaybe<Scalars['String']['input']>;
  linkUrl_gte?: InputMaybe<Scalars['String']['input']>;
  linkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl_lt?: InputMaybe<Scalars['String']['input']>;
  linkUrl_lte?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  linkUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  newsletterDuplications_some?: InputMaybe<NewsletterDuplicationWhereInput>;
  newsletterGenerations_some?: InputMaybe<NewsletterGenerationWhereInput>;
  newsletterHistories_some?: InputMaybe<NewsletterHistoryWhereInput>;
  nlfName?: InputMaybe<Scalars['String']['input']>;
  nlfName_contains?: InputMaybe<Scalars['String']['input']>;
  nlfName_ends_with?: InputMaybe<Scalars['String']['input']>;
  nlfName_gt?: InputMaybe<Scalars['String']['input']>;
  nlfName_gte?: InputMaybe<Scalars['String']['input']>;
  nlfName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nlfName_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  nlfName_lt?: InputMaybe<Scalars['String']['input']>;
  nlfName_lte?: InputMaybe<Scalars['String']['input']>;
  nlfName_not?: InputMaybe<Scalars['String']['input']>;
  nlfName_not_contains?: InputMaybe<Scalars['String']['input']>;
  nlfName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  nlfName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nlfName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  nlfName_starts_with?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<NewsletterWhereInput>;
  OR?: InputMaybe<Array<NewsletterWhereInput>>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  previewUrl_contains?: InputMaybe<Scalars['String']['input']>;
  previewUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  previewUrl_gt?: InputMaybe<Scalars['String']['input']>;
  previewUrl_gte?: InputMaybe<Scalars['String']['input']>;
  previewUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previewUrl_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  previewUrl_lt?: InputMaybe<Scalars['String']['input']>;
  previewUrl_lte?: InputMaybe<Scalars['String']['input']>;
  previewUrl_not?: InputMaybe<Scalars['String']['input']>;
  previewUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  previewUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  previewUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previewUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  previewUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  rawMedias?: InputMaybe<Scalars['String']['input']>;
  rawMedias_contains?: InputMaybe<Scalars['String']['input']>;
  rawMedias_ends_with?: InputMaybe<Scalars['String']['input']>;
  rawMedias_gt?: InputMaybe<Scalars['String']['input']>;
  rawMedias_gte?: InputMaybe<Scalars['String']['input']>;
  rawMedias_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rawMedias_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  rawMedias_lt?: InputMaybe<Scalars['String']['input']>;
  rawMedias_lte?: InputMaybe<Scalars['String']['input']>;
  rawMedias_not?: InputMaybe<Scalars['String']['input']>;
  rawMedias_not_contains?: InputMaybe<Scalars['String']['input']>;
  rawMedias_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  rawMedias_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rawMedias_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  rawMedias_starts_with?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Scalars['String']['input']>;
  sections_contains?: InputMaybe<Scalars['String']['input']>;
  sections_ends_with?: InputMaybe<Scalars['String']['input']>;
  sections_gt?: InputMaybe<Scalars['String']['input']>;
  sections_gte?: InputMaybe<Scalars['String']['input']>;
  sections_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sections_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  sections_lt?: InputMaybe<Scalars['String']['input']>;
  sections_lte?: InputMaybe<Scalars['String']['input']>;
  sections_not?: InputMaybe<Scalars['String']['input']>;
  sections_not_contains?: InputMaybe<Scalars['String']['input']>;
  sections_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  sections_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sections_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  sections_starts_with?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['Date']['input']>;
  sentAt_gt?: InputMaybe<Scalars['Date']['input']>;
  sentAt_gte?: InputMaybe<Scalars['Date']['input']>;
  sentAt_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  sentAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  sentAt_lt?: InputMaybe<Scalars['Date']['input']>;
  sentAt_lte?: InputMaybe<Scalars['Date']['input']>;
  sentAt_not?: InputMaybe<Scalars['Date']['input']>;
  sentAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export enum BrandKey {
  CAC = 'CAC',
  CAM = 'CAM',
  CAP = 'CAP',
  FAC = 'FAC',
  FRGTS = 'FRGTS',
  FROMM = 'FROMM',
  GAL = 'GAL',
  GEO = 'GEO',
  HBR = 'HBR',
  HBZ = 'HBZ',
  NEO = 'NEO',
  TEL = 'TEL',
  TGC = 'TGC',
  TLS = 'TLS',
  TRV = 'TRV',
  VOI = 'VOI'
}

/** Filters the "NewsletterDuplication" nodes by specifying some conditions */
export type NewsletterDuplicationWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<NewsletterDuplicationWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  duplicationDate?: InputMaybe<Scalars['String']['input']>;
  duplicationDate_contains?: InputMaybe<Scalars['String']['input']>;
  duplicationDate_ends_with?: InputMaybe<Scalars['String']['input']>;
  duplicationDate_gt?: InputMaybe<Scalars['String']['input']>;
  duplicationDate_gte?: InputMaybe<Scalars['String']['input']>;
  duplicationDate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  duplicationDate_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  duplicationDate_lt?: InputMaybe<Scalars['String']['input']>;
  duplicationDate_lte?: InputMaybe<Scalars['String']['input']>;
  duplicationDate_not?: InputMaybe<Scalars['String']['input']>;
  duplicationDate_not_contains?: InputMaybe<Scalars['String']['input']>;
  duplicationDate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  duplicationDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  duplicationDate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  duplicationDate_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  newsletter?: InputMaybe<NewsletterWhereInput>;
  newsletter_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<NewsletterDuplicationWhereInput>;
  OR?: InputMaybe<Array<NewsletterDuplicationWhereInput>>;
  target?: InputMaybe<Scalars['Int']['input']>;
  target_gt?: InputMaybe<Scalars['Int']['input']>;
  target_gte?: InputMaybe<Scalars['Int']['input']>;
  target_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  target_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  target_lt?: InputMaybe<Scalars['Int']['input']>;
  target_lte?: InputMaybe<Scalars['Int']['input']>;
  target_not?: InputMaybe<Scalars['Int']['input']>;
  target_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Filters the "NewsletterGeneration" nodes by specifying some conditions */
export type NewsletterGenerationWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<NewsletterGenerationWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  inError?: InputMaybe<Scalars['Boolean']['input']>;
  inError_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  inError_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  inError_not?: InputMaybe<Scalars['Boolean']['input']>;
  inError_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  newsletter?: InputMaybe<NewsletterWhereInput>;
  newsletter_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<NewsletterGenerationWhereInput>;
  OR?: InputMaybe<Array<NewsletterGenerationWhereInput>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_contains?: InputMaybe<Scalars['String']['input']>;
  reason_ends_with?: InputMaybe<Scalars['String']['input']>;
  reason_gt?: InputMaybe<Scalars['String']['input']>;
  reason_gte?: InputMaybe<Scalars['String']['input']>;
  reason_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reason_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  reason_lt?: InputMaybe<Scalars['String']['input']>;
  reason_lte?: InputMaybe<Scalars['String']['input']>;
  reason_not?: InputMaybe<Scalars['String']['input']>;
  reason_not_contains?: InputMaybe<Scalars['String']['input']>;
  reason_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  reason_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reason_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  reason_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Filters the "NewsletterHistory" nodes by specifying some conditions */
export type NewsletterHistoryWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<NewsletterHistoryWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  migration?: InputMaybe<Scalars['String']['input']>;
  migration_contains?: InputMaybe<Scalars['String']['input']>;
  migration_ends_with?: InputMaybe<Scalars['String']['input']>;
  migration_gt?: InputMaybe<Scalars['String']['input']>;
  migration_gte?: InputMaybe<Scalars['String']['input']>;
  migration_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  migration_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  migration_lt?: InputMaybe<Scalars['String']['input']>;
  migration_lte?: InputMaybe<Scalars['String']['input']>;
  migration_not?: InputMaybe<Scalars['String']['input']>;
  migration_not_contains?: InputMaybe<Scalars['String']['input']>;
  migration_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  migration_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  migration_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  migration_starts_with?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<NewsletterWhereInput>;
  newsletter_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<NewsletterHistoryWhereInput>;
  OR?: InputMaybe<Array<NewsletterHistoryWhereInput>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_not?: InputMaybe<Scalars['ID']['input']>;
  userId_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  userName?: InputMaybe<Scalars['String']['input']>;
  userName_contains?: InputMaybe<Scalars['String']['input']>;
  userName_ends_with?: InputMaybe<Scalars['String']['input']>;
  userName_gt?: InputMaybe<Scalars['String']['input']>;
  userName_gte?: InputMaybe<Scalars['String']['input']>;
  userName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  userName_lt?: InputMaybe<Scalars['String']['input']>;
  userName_lte?: InputMaybe<Scalars['String']['input']>;
  userName_not?: InputMaybe<Scalars['String']['input']>;
  userName_not_contains?: InputMaybe<Scalars['String']['input']>;
  userName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  userName_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  userName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  userName_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum BlockOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  articleId_ASC = 'articleId_ASC',
  articleId_DESC = 'articleId_DESC',
  blockType_ASC = 'blockType_ASC',
  blockType_DESC = 'blockType_DESC',
  body_ASC = 'body_ASC',
  body_DESC = 'body_DESC',
  content_ASC = 'content_ASC',
  content_DESC = 'content_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isAutomated_ASC = 'isAutomated_ASC',
  isAutomated_DESC = 'isAutomated_DESC',
  isAutoPromo_ASC = 'isAutoPromo_ASC',
  isAutoPromo_DESC = 'isAutoPromo_DESC',
  leadIn_ASC = 'leadIn_ASC',
  leadIn_DESC = 'leadIn_DESC',
  linkLabel_ASC = 'linkLabel_ASC',
  linkLabel_DESC = 'linkLabel_DESC',
  position_ASC = 'position_ASC',
  position_DESC = 'position_DESC',
  rawMedia_ASC = 'rawMedia_ASC',
  rawMedia_DESC = 'rawMedia_DESC',
  surTitle_ASC = 'surTitle_ASC',
  surTitle_DESC = 'surTitle_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC'
}

/** "Campaign" resource's node */
export type Campaign = {
  __typename?: 'Campaign';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  availableAt?: Maybe<Scalars['Date']['output']>;
  /** "CampaignHistory.campaign"'s inverse relation */
  campaignHistories: Array<CampaignHistory>;
  /** "CampaignHistory.campaign"'s inverse relation count */
  campaignHistoryCount: Scalars['Int']['output'];
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** Number of blocks edited by users currently the campaign */
  editedBlocksCount?: Maybe<Scalars['String']['output']>;
  /** The public ID */
  id: Scalars['ID']['output'];
  /** State of current campaign (locked or not) */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** The date of the campaign's last lock */
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user currently locking the campaign */
  lockedBy?: Maybe<User>;
  lockerId?: Maybe<Scalars['ID']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  newsletter?: Maybe<Newsletter>;
  preHeader?: Maybe<Scalars['String']['output']>;
  rawMedias?: Maybe<Scalars['String']['output']>;
  /** "Section.campaign"'s inverse relation count */
  sectionCount: Scalars['Int']['output'];
  /** "Section.campaign"'s inverse relation */
  sections: Array<Section>;
  subject: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
};


/** "Campaign" resource's node */
export type CampaignCampaignHistoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CampaignHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CampaignHistoryWhereInput>;
};


/** "Campaign" resource's node */
export type CampaignCampaignHistoryCountArgs = {
  where?: InputMaybe<CampaignHistoryWhereInput>;
};


/** "Campaign" resource's node */
export type CampaignSectionCountArgs = {
  where?: InputMaybe<SectionWhereInput>;
};


/** "Campaign" resource's node */
export type CampaignSectionsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<SectionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SectionWhereInput>;
};

export enum CampaignHistoryOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  userId_ASC = 'userId_ASC',
  userId_DESC = 'userId_DESC',
  userName_ASC = 'userName_ASC',
  userName_DESC = 'userName_DESC'
}

/** "CampaignHistory" resource's node */
export type CampaignHistory = {
  __typename?: 'CampaignHistory';
  campaign: Campaign;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['ID']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
};

/** "Newsletter" resource's node */
export type Newsletter = {
  __typename?: 'Newsletter';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  aiDefaultPromptHeader?: Maybe<Scalars['String']['output']>;
  aiDefaultPromptObject?: Maybe<Scalars['String']['output']>;
  aiUserPromptHeader?: Maybe<Scalars['String']['output']>;
  aiUserPromptObject?: Maybe<Scalars['String']['output']>;
  /** JSON automation config */
  automationConfig?: Maybe<Scalars['String']['output']>;
  /** JSON automation query */
  automationQuery?: Maybe<Scalars['String']['output']>;
  /** Store time (at Europe/Paris Timezone) to run automated campaign creation. eg: "10h15" => 1015 */
  automationTime?: Maybe<Scalars['Int']['output']>;
  autoValidateXMLCampaign?: Maybe<Scalars['Boolean']['output']>;
  available?: Maybe<Scalars['String']['output']>;
  brandKey: BrandKey;
  /** "Campaign.newsletter"'s inverse relation count */
  campaignCount: Scalars['Int']['output'];
  campaignPreHeaderPattern?: Maybe<Scalars['String']['output']>;
  /** "Campaign.newsletter"'s inverse relation */
  campaigns: Array<Campaign>;
  campaignSubjectPattern?: Maybe<Scalars['String']['output']>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  defaultCampaignSectionCount?: Maybe<Scalars['Int']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  /** The public ID */
  id: Scalars['ID']['output'];
  isFromNlf?: Maybe<Scalars['Boolean']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  name: Scalars['String']['output'];
  /** "NewsletterDuplication.newsletter"'s inverse relation count */
  newsletterDuplicationCount: Scalars['Int']['output'];
  /** "NewsletterDuplication.newsletter"'s inverse relation */
  newsletterDuplications: Array<NewsletterDuplication>;
  /** "NewsletterGeneration.newsletter"'s inverse relation count */
  newsletterGenerationCount: Scalars['Int']['output'];
  /** "NewsletterGeneration.newsletter"'s inverse relation */
  newsletterGenerations: Array<NewsletterGeneration>;
  /** "NewsletterHistory.newsletter"'s inverse relation */
  newsletterHistories: Array<NewsletterHistory>;
  /** "NewsletterHistory.newsletter"'s inverse relation count */
  newsletterHistoryCount: Scalars['Int']['output'];
  nlFactoryObject?: Maybe<NewsletterNlf>;
  nlfName?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  previewUrlNlf?: Maybe<Scalars['String']['output']>;
  rawMedias?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Scalars['String']['output']>;
  sectionsNlf?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['Date']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** "Newsletter" resource's node */
export type NewsletterCampaignCountArgs = {
  where?: InputMaybe<CampaignWhereInput>;
};


/** "Newsletter" resource's node */
export type NewsletterCampaignsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CampaignOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CampaignWhereInput>;
};


/** "Newsletter" resource's node */
export type NewsletterNewsletterDuplicationCountArgs = {
  where?: InputMaybe<NewsletterDuplicationWhereInput>;
};


/** "Newsletter" resource's node */
export type NewsletterNewsletterDuplicationsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<NewsletterDuplicationOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NewsletterDuplicationWhereInput>;
};


/** "Newsletter" resource's node */
export type NewsletterNewsletterGenerationCountArgs = {
  where?: InputMaybe<NewsletterGenerationWhereInput>;
};


/** "Newsletter" resource's node */
export type NewsletterNewsletterGenerationsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<NewsletterGenerationOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NewsletterGenerationWhereInput>;
};


/** "Newsletter" resource's node */
export type NewsletterNewsletterHistoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<NewsletterHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NewsletterHistoryWhereInput>;
};


/** "Newsletter" resource's node */
export type NewsletterNewsletterHistoryCountArgs = {
  where?: InputMaybe<NewsletterHistoryWhereInput>;
};

export enum CampaignOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  availableAt_ASC = 'availableAt_ASC',
  availableAt_DESC = 'availableAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  lockedAt_ASC = 'lockedAt_ASC',
  lockedAt_DESC = 'lockedAt_DESC',
  lockerId_ASC = 'lockerId_ASC',
  lockerId_DESC = 'lockerId_DESC',
  preHeader_ASC = 'preHeader_ASC',
  preHeader_DESC = 'preHeader_DESC',
  rawMedias_ASC = 'rawMedias_ASC',
  rawMedias_DESC = 'rawMedias_DESC',
  subject_ASC = 'subject_ASC',
  subject_DESC = 'subject_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC',
  utmContent_ASC = 'utmContent_ASC',
  utmContent_DESC = 'utmContent_DESC'
}

export enum NewsletterDuplicationOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  duplicationDate_ASC = 'duplicationDate_ASC',
  duplicationDate_DESC = 'duplicationDate_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  target_ASC = 'target_ASC',
  target_DESC = 'target_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** "NewsletterDuplication" resource's node */
export type NewsletterDuplication = {
  __typename?: 'NewsletterDuplication';
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  duplicationDate?: Maybe<Scalars['String']['output']>;
  /** The public ID */
  id: Scalars['ID']['output'];
  newsletter?: Maybe<Newsletter>;
  target?: Maybe<Scalars['Int']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export enum NewsletterGenerationOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  inError_ASC = 'inError_ASC',
  inError_DESC = 'inError_DESC',
  reason_ASC = 'reason_ASC',
  reason_DESC = 'reason_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** "NewsletterGeneration" resource's node */
export type NewsletterGeneration = {
  __typename?: 'NewsletterGeneration';
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['ID']['output'];
  inError?: Maybe<Scalars['Boolean']['output']>;
  newsletter?: Maybe<Newsletter>;
  reason?: Maybe<Scalars['String']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export enum NewsletterHistoryOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  migration_ASC = 'migration_ASC',
  migration_DESC = 'migration_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  userId_ASC = 'userId_ASC',
  userId_DESC = 'userId_DESC',
  userName_ASC = 'userName_ASC',
  userName_DESC = 'userName_DESC'
}

/** "NewsletterHistory" resource's node */
export type NewsletterHistory = {
  __typename?: 'NewsletterHistory';
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['ID']['output'];
  migration?: Maybe<Scalars['String']['output']>;
  newsletter?: Maybe<Newsletter>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type NewsletterNlf = {
  __typename?: 'NewsletterNlf';
  name?: Maybe<Scalars['String']['output']>;
  nb_article_blocks?: Maybe<Scalars['Int']['output']>;
  public_url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sections?: Maybe<Scalars['JSONObject']['output']>;
  structure?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum SectionOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  position_ASC = 'position_ASC',
  position_DESC = 'position_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC'
}

/**
 * Identifies exactly one "Campaign" node with one of these unique combinations of values:
 * - _id
 * - id
 * - availableAt, newsletter
 */
export type CampaignWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  availableAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  newsletter?: InputMaybe<NewsletterWhereUniqueInput>;
};

/**
 * Identifies exactly one "Newsletter" node with one of these unique combinations of values:
 * - _id
 * - id
 * - brandKey, name, nlfName
 */
export type NewsletterWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nlfName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Identifies exactly one "CampaignHistory" node with one of these unique values:
 * - _id
 * - id
 */
export type CampaignHistoryWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum FlashSenderHistoryOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  link_ASC = 'link_ASC',
  link_DESC = 'link_DESC',
  resource_ASC = 'resource_ASC',
  resource_DESC = 'resource_DESC',
  response_ASC = 'response_ASC',
  response_DESC = 'response_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  user_ASC = 'user_ASC',
  user_DESC = 'user_DESC',
  uuid_ASC = 'uuid_ASC',
  uuid_DESC = 'uuid_DESC'
}

/** Filters the "FlashSenderHistory" nodes by specifying some conditions */
export type FlashSenderHistoryWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<FlashSenderHistoryWhereInput>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  link?: InputMaybe<Scalars['String']['input']>;
  link_contains?: InputMaybe<Scalars['String']['input']>;
  link_ends_with?: InputMaybe<Scalars['String']['input']>;
  link_gt?: InputMaybe<Scalars['String']['input']>;
  link_gte?: InputMaybe<Scalars['String']['input']>;
  link_in?: InputMaybe<Array<Scalars['String']['input']>>;
  link_lt?: InputMaybe<Scalars['String']['input']>;
  link_lte?: InputMaybe<Scalars['String']['input']>;
  link_not?: InputMaybe<Scalars['String']['input']>;
  link_not_contains?: InputMaybe<Scalars['String']['input']>;
  link_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  link_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  link_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  link_starts_with?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<FlashSenderHistoryWhereInput>;
  OR?: InputMaybe<Array<FlashSenderHistoryWhereInput>>;
  resource?: InputMaybe<ContentType>;
  resource_in?: InputMaybe<Array<ContentType>>;
  resource_not?: InputMaybe<ContentType>;
  resource_not_in?: InputMaybe<Array<ContentType>>;
  response?: InputMaybe<Scalars['String']['input']>;
  response_contains?: InputMaybe<Scalars['String']['input']>;
  response_ends_with?: InputMaybe<Scalars['String']['input']>;
  response_gt?: InputMaybe<Scalars['String']['input']>;
  response_gte?: InputMaybe<Scalars['String']['input']>;
  response_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  response_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  response_lt?: InputMaybe<Scalars['String']['input']>;
  response_lte?: InputMaybe<Scalars['String']['input']>;
  response_not?: InputMaybe<Scalars['String']['input']>;
  response_not_contains?: InputMaybe<Scalars['String']['input']>;
  response_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  response_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  response_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  response_starts_with?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  status_gt?: InputMaybe<Scalars['Int']['input']>;
  status_gte?: InputMaybe<Scalars['Int']['input']>;
  status_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  status_lt?: InputMaybe<Scalars['Int']['input']>;
  status_lte?: InputMaybe<Scalars['Int']['input']>;
  status_not?: InputMaybe<Scalars['Int']['input']>;
  status_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuid_contains?: InputMaybe<Scalars['String']['input']>;
  uuid_ends_with?: InputMaybe<Scalars['String']['input']>;
  uuid_gt?: InputMaybe<Scalars['String']['input']>;
  uuid_gte?: InputMaybe<Scalars['String']['input']>;
  uuid_in?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid_lt?: InputMaybe<Scalars['String']['input']>;
  uuid_lte?: InputMaybe<Scalars['String']['input']>;
  uuid_not?: InputMaybe<Scalars['String']['input']>;
  uuid_not_contains?: InputMaybe<Scalars['String']['input']>;
  uuid_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  uuid_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  uuid_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum ContentType {
  ARTICLE = 'ARTICLE',
  DIAPO = 'DIAPO',
  EMPTY = 'EMPTY',
  RECIPE = 'RECIPE',
  VIDEO = 'VIDEO'
}

/** "FlashSenderHistory" resource's node */
export type FlashSenderHistory = {
  __typename?: 'FlashSenderHistory';
  brandKey: BrandKey;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  resource: ContentType;
  response?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  user: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/**
 * Identifies exactly one "FlashSenderHistory" node with one of these unique values:
 * - _id
 * - id
 */
export type FlashSenderHistoryWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Identifies exactly one "NewsletterDuplication" node with one of these unique values:
 * - _id
 * - id
 */
export type NewsletterDuplicationWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Identifies exactly one "NewsletterGeneration" node with one of these unique values:
 * - _id
 * - id
 */
export type NewsletterGenerationWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Identifies exactly one "NewsletterHistory" node with one of these unique values:
 * - _id
 * - id
 */
export type NewsletterHistoryWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum NewsletterOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  aiDefaultPromptHeader_ASC = 'aiDefaultPromptHeader_ASC',
  aiDefaultPromptHeader_DESC = 'aiDefaultPromptHeader_DESC',
  aiDefaultPromptObject_ASC = 'aiDefaultPromptObject_ASC',
  aiDefaultPromptObject_DESC = 'aiDefaultPromptObject_DESC',
  aiUserPromptHeader_ASC = 'aiUserPromptHeader_ASC',
  aiUserPromptHeader_DESC = 'aiUserPromptHeader_DESC',
  aiUserPromptObject_ASC = 'aiUserPromptObject_ASC',
  aiUserPromptObject_DESC = 'aiUserPromptObject_DESC',
  automationConfig_ASC = 'automationConfig_ASC',
  automationConfig_DESC = 'automationConfig_DESC',
  automationQuery_ASC = 'automationQuery_ASC',
  automationQuery_DESC = 'automationQuery_DESC',
  automationTime_ASC = 'automationTime_ASC',
  automationTime_DESC = 'automationTime_DESC',
  autoValidateXMLCampaign_ASC = 'autoValidateXMLCampaign_ASC',
  autoValidateXMLCampaign_DESC = 'autoValidateXMLCampaign_DESC',
  available_ASC = 'available_ASC',
  available_DESC = 'available_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  campaignPreHeaderPattern_ASC = 'campaignPreHeaderPattern_ASC',
  campaignPreHeaderPattern_DESC = 'campaignPreHeaderPattern_DESC',
  campaignSubjectPattern_ASC = 'campaignSubjectPattern_ASC',
  campaignSubjectPattern_DESC = 'campaignSubjectPattern_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  defaultCampaignSectionCount_ASC = 'defaultCampaignSectionCount_ASC',
  defaultCampaignSectionCount_DESC = 'defaultCampaignSectionCount_DESC',
  frequency_ASC = 'frequency_ASC',
  frequency_DESC = 'frequency_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isFromNlf_ASC = 'isFromNlf_ASC',
  isFromNlf_DESC = 'isFromNlf_DESC',
  linkUrl_ASC = 'linkUrl_ASC',
  linkUrl_DESC = 'linkUrl_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  nlfName_ASC = 'nlfName_ASC',
  nlfName_DESC = 'nlfName_DESC',
  previewUrl_ASC = 'previewUrl_ASC',
  previewUrl_DESC = 'previewUrl_DESC',
  rawMedias_ASC = 'rawMedias_ASC',
  rawMedias_DESC = 'rawMedias_DESC',
  sections_ASC = 'sections_ASC',
  sections_DESC = 'sections_DESC',
  sentAt_ASC = 'sentAt_ASC',
  sentAt_DESC = 'sentAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * Identifies exactly one "Section" node with one of these unique values:
 * - _id
 * - id
 */
export type SectionWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create a single "Block" node. */
  createBlock: Block;
  /** Create a single "Campaign" node. */
  createCampaign: Campaign;
  /** Create a single "CampaignHistory" node. */
  createCampaignHistory: CampaignHistory;
  /** Create a single "FlashSenderHistory" node. */
  createFlashSenderHistory: FlashSenderHistory;
  /** Create a single "Newsletter" node. */
  createNewsletter: Newsletter;
  /** Create a single "NewsletterDuplication" node. */
  createNewsletterDuplication: NewsletterDuplication;
  /** Create a single "NewsletterGeneration" node. */
  createNewsletterGeneration: NewsletterGeneration;
  /** Create a single "NewsletterHistory" node. */
  createNewsletterHistory: NewsletterHistory;
  /** Create a single "Section" node. */
  createSection: Section;
  /** Delete a single "Block" node. */
  deleteBlock?: Maybe<Block>;
  /** Delete a single "Campaign" node. */
  deleteCampaign?: Maybe<Campaign>;
  /** Delete a single "CampaignHistory" node. */
  deleteCampaignHistory?: Maybe<CampaignHistory>;
  /** Delete a single "FlashSenderHistory" node. */
  deleteFlashSenderHistory?: Maybe<FlashSenderHistory>;
  /** Delete a single "Newsletter" node. */
  deleteNewsletter?: Maybe<Newsletter>;
  /** Delete a single "NewsletterDuplication" node. */
  deleteNewsletterDuplication?: Maybe<NewsletterDuplication>;
  /** Delete a single "NewsletterGeneration" node. */
  deleteNewsletterGeneration?: Maybe<NewsletterGeneration>;
  /** Delete a single "NewsletterHistory" node. */
  deleteNewsletterHistory?: Maybe<NewsletterHistory>;
  /** Delete a single "Section" node. */
  deleteSection?: Maybe<Section>;
  /** Send a instant NL */
  sendNlFlash?: Maybe<Scalars['String']['output']>;
  /** Update a single "Block" node. */
  updateBlock?: Maybe<Block>;
  /** Update a single "Campaign" node. */
  updateCampaign?: Maybe<Campaign>;
  /** Update a single "CampaignHistory" node. */
  updateCampaignHistory?: Maybe<CampaignHistory>;
  /** Update a single "FlashSenderHistory" node. */
  updateFlashSenderHistory?: Maybe<FlashSenderHistory>;
  /** Update a single "Newsletter" node. */
  updateNewsletter?: Maybe<Newsletter>;
  /** Update a single "NewsletterDuplication" node. */
  updateNewsletterDuplication?: Maybe<NewsletterDuplication>;
  /** Update a single "NewsletterGeneration" node. */
  updateNewsletterGeneration?: Maybe<NewsletterGeneration>;
  /** Update a single "NewsletterHistory" node. */
  updateNewsletterHistory?: Maybe<NewsletterHistory>;
  /** Update a single "Section" node. */
  updateSection?: Maybe<Section>;
  /** Update or create a single "Block" node. */
  upsertBlock: Block;
  /** Update or create a single "Campaign" node. */
  upsertCampaign: Campaign;
  /** Update or create a single "CampaignHistory" node. */
  upsertCampaignHistory: CampaignHistory;
  /** Update or create a single "FlashSenderHistory" node. */
  upsertFlashSenderHistory: FlashSenderHistory;
  /** Update or create a single "Newsletter" node. */
  upsertNewsletter: Newsletter;
  /** Update or create a single "NewsletterDuplication" node. */
  upsertNewsletterDuplication: NewsletterDuplication;
  /** Update or create a single "NewsletterGeneration" node. */
  upsertNewsletterGeneration: NewsletterGeneration;
  /** Update or create a single "NewsletterHistory" node. */
  upsertNewsletterHistory: NewsletterHistory;
  /** Update or create a single "Section" node. */
  upsertSection: Section;
};


export type MutationCreateBlockArgs = {
  data: BlockCreateInput;
};


export type MutationCreateCampaignArgs = {
  data: CampaignCreateInput;
};


export type MutationCreateCampaignHistoryArgs = {
  data: CampaignHistoryCreateInput;
};


export type MutationCreateFlashSenderHistoryArgs = {
  data: FlashSenderHistoryCreateInput;
};


export type MutationCreateNewsletterArgs = {
  data: NewsletterCreateInput;
};


export type MutationCreateNewsletterDuplicationArgs = {
  data: NewsletterDuplicationCreateInput;
};


export type MutationCreateNewsletterGenerationArgs = {
  data: NewsletterGenerationCreateInput;
};


export type MutationCreateNewsletterHistoryArgs = {
  data: NewsletterHistoryCreateInput;
};


export type MutationCreateSectionArgs = {
  data: SectionCreateInput;
};


export type MutationDeleteBlockArgs = {
  where: BlockWhereUniqueInput;
};


export type MutationDeleteCampaignArgs = {
  where: CampaignWhereUniqueInput;
};


export type MutationDeleteCampaignHistoryArgs = {
  where: CampaignHistoryWhereUniqueInput;
};


export type MutationDeleteFlashSenderHistoryArgs = {
  where: FlashSenderHistoryWhereUniqueInput;
};


export type MutationDeleteNewsletterArgs = {
  where: NewsletterWhereUniqueInput;
};


export type MutationDeleteNewsletterDuplicationArgs = {
  where: NewsletterDuplicationWhereUniqueInput;
};


export type MutationDeleteNewsletterGenerationArgs = {
  where: NewsletterGenerationWhereUniqueInput;
};


export type MutationDeleteNewsletterHistoryArgs = {
  where: NewsletterHistoryWhereUniqueInput;
};


export type MutationDeleteSectionArgs = {
  where: SectionWhereUniqueInput;
};


export type MutationSendNlFlashArgs = {
  brandKey: BrandKey;
  contentUrl: Scalars['String']['input'];
  img: Scalars['String']['input'];
  imgAlt: Scalars['String']['input'];
  resource: ContentType;
  subject: Scalars['String']['input'];
  teaser: Scalars['String']['input'];
  title: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationUpdateBlockArgs = {
  data: BlockUpdateInput;
  where: BlockWhereUniqueInput;
};


export type MutationUpdateCampaignArgs = {
  data: CampaignUpdateInput;
  where: CampaignWhereUniqueInput;
};


export type MutationUpdateCampaignHistoryArgs = {
  data: CampaignHistoryUpdateInput;
  where: CampaignHistoryWhereUniqueInput;
};


export type MutationUpdateFlashSenderHistoryArgs = {
  data: FlashSenderHistoryUpdateInput;
  where: FlashSenderHistoryWhereUniqueInput;
};


export type MutationUpdateNewsletterArgs = {
  data: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};


export type MutationUpdateNewsletterDuplicationArgs = {
  data: NewsletterDuplicationUpdateInput;
  where: NewsletterDuplicationWhereUniqueInput;
};


export type MutationUpdateNewsletterGenerationArgs = {
  data: NewsletterGenerationUpdateInput;
  where: NewsletterGenerationWhereUniqueInput;
};


export type MutationUpdateNewsletterHistoryArgs = {
  data: NewsletterHistoryUpdateInput;
  where: NewsletterHistoryWhereUniqueInput;
};


export type MutationUpdateSectionArgs = {
  data: SectionUpdateInput;
  where: SectionWhereUniqueInput;
};


export type MutationUpsertBlockArgs = {
  create: BlockCreateInput;
  update: BlockUpdateInput;
  where: BlockWhereUniqueInput;
};


export type MutationUpsertCampaignArgs = {
  create: CampaignCreateInput;
  update: CampaignUpdateInput;
  where: CampaignWhereUniqueInput;
};


export type MutationUpsertCampaignHistoryArgs = {
  create: CampaignHistoryCreateInput;
  update: CampaignHistoryUpdateInput;
  where: CampaignHistoryWhereUniqueInput;
};


export type MutationUpsertFlashSenderHistoryArgs = {
  create: FlashSenderHistoryCreateInput;
  update: FlashSenderHistoryUpdateInput;
  where: FlashSenderHistoryWhereUniqueInput;
};


export type MutationUpsertNewsletterArgs = {
  create: NewsletterCreateInput;
  update: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};


export type MutationUpsertNewsletterDuplicationArgs = {
  create: NewsletterDuplicationCreateInput;
  update: NewsletterDuplicationUpdateInput;
  where: NewsletterDuplicationWhereUniqueInput;
};


export type MutationUpsertNewsletterGenerationArgs = {
  create: NewsletterGenerationCreateInput;
  update: NewsletterGenerationUpdateInput;
  where: NewsletterGenerationWhereUniqueInput;
};


export type MutationUpsertNewsletterHistoryArgs = {
  create: NewsletterHistoryCreateInput;
  update: NewsletterHistoryUpdateInput;
  where: NewsletterHistoryWhereUniqueInput;
};


export type MutationUpsertSectionArgs = {
  create: SectionCreateInput;
  update: SectionUpdateInput;
  where: SectionWhereUniqueInput;
};

export type BlockCreateInput = {
  /** The article ID */
  articleId?: InputMaybe<Scalars['ID']['input']>;
  blockType?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Is the block automated */
  isAutomated?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoPromo?: InputMaybe<Scalars['Boolean']['input']>;
  leadIn?: InputMaybe<Scalars['Boolean']['input']>;
  linkLabel?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  rawMedia?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Block.section" relation */
  section?: InputMaybe<BlockNestedSectionCreateInput>;
  surTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type BlockNestedSectionCreateInput = {
  /** Connect an existing "Section" node to the new "Block" node, through the "Block.section" relation. */
  connect?: InputMaybe<SectionWhereUniqueInput>;
  /** Create a new "Section" node and connect it to the new "Block" node, through the "Block.section" relation. */
  create?: InputMaybe<SectionCreateInput>;
  /** Update an existing "Section" node and connect it to the new "Block" node, through the "Block.section" relation. */
  update?: InputMaybe<BlockNestedUpdateSectionCreateInput>;
  /** Create or update a "Section" node and connect it to the new "Block" node, through the "Block.section" relation. */
  upsert?: InputMaybe<BlockNestedUpsertSectionCreateInput>;
};

export type SectionCreateInput = {
  /** Actions for the "Section.blocks" relation: "Block.section"'s inverse relation */
  blocks?: InputMaybe<SectionNestedBlocksCreateInput>;
  /** Actions for the "Section.campaign" relation */
  campaign: SectionNestedCampaignCreateInput;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SectionNestedBlocksCreateInput = {
  /** Connect existing "Block" nodes to the new "Section" node, through the "Section.blocks" relation. */
  connect?: InputMaybe<Array<BlockWhereUniqueInput>>;
  /** Create new "Block" nodes and connect them to the new "Section" node, through the "Section.blocks" relation. */
  create?: InputMaybe<Array<BlockWithForcedSectionCreateInput>>;
};

export type BlockWithForcedSectionCreateInput = {
  /** The article ID */
  articleId?: InputMaybe<Scalars['ID']['input']>;
  blockType?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Is the block automated */
  isAutomated?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoPromo?: InputMaybe<Scalars['Boolean']['input']>;
  leadIn?: InputMaybe<Scalars['Boolean']['input']>;
  linkLabel?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  rawMedia?: InputMaybe<Scalars['String']['input']>;
  surTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SectionNestedCampaignCreateInput = {
  /** Connect an existing "Campaign" node to the new "Section" node, through the "Section.campaign" relation. */
  connect?: InputMaybe<CampaignWhereUniqueInput>;
  /** Create a new "Campaign" node and connect it to the new "Section" node, through the "Section.campaign" relation. */
  create?: InputMaybe<CampaignCreateInput>;
  /** Update an existing "Campaign" node and connect it to the new "Section" node, through the "Section.campaign" relation. */
  update?: InputMaybe<SectionNestedUpdateCampaignCreateInput>;
  /** Create or update a "Campaign" node and connect it to the new "Section" node, through the "Section.campaign" relation. */
  upsert?: InputMaybe<SectionNestedUpsertCampaignCreateInput>;
};

export type CampaignCreateInput = {
  availableAt?: InputMaybe<Scalars['Date']['input']>;
  /** Actions for the "Campaign.campaignHistories" relation: "CampaignHistory.campaign"'s inverse relation */
  campaignHistories?: InputMaybe<CampaignNestedCampaignHistoriesCreateInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "Campaign.newsletter" relation */
  newsletter?: InputMaybe<CampaignNestedNewsletterCreateInput>;
  preHeader?: InputMaybe<Scalars['String']['input']>;
  rawMedias?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Campaign.sections" relation: "Section.campaign"'s inverse relation */
  sections?: InputMaybe<CampaignNestedSectionsCreateInput>;
  subject: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignNestedCampaignHistoriesCreateInput = {
  /** Connect existing "CampaignHistory" nodes to the new "Campaign" node, through the "Campaign.campaignHistories" relation. */
  connect?: InputMaybe<Array<CampaignHistoryWhereUniqueInput>>;
  /**
   * Create new "CampaignHistory" nodes and connect them to the new "Campaign"
   * node, through the "Campaign.campaignHistories" relation.
   */
  create?: InputMaybe<Array<CampaignHistoryWithForcedCampaignCreateInput>>;
};

export type CampaignHistoryWithForcedCampaignCreateInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
  userName: Scalars['String']['input'];
};

export type CampaignNestedNewsletterCreateInput = {
  /** Connect an existing "Newsletter" node to the new "Campaign" node, through the "Campaign.newsletter" relation. */
  connect?: InputMaybe<NewsletterWhereUniqueInput>;
  /** Create a new "Newsletter" node and connect it to the new "Campaign" node, through the "Campaign.newsletter" relation. */
  create?: InputMaybe<NewsletterCreateInput>;
  /**
   * Update an existing "Newsletter" node and connect it to the new "Campaign"
   * node, through the "Campaign.newsletter" relation.
   */
  update?: InputMaybe<CampaignNestedUpdateNewsletterCreateInput>;
  /**
   * Create or update a "Newsletter" node and connect it to the new "Campaign"
   * node, through the "Campaign.newsletter" relation.
   */
  upsert?: InputMaybe<CampaignNestedUpsertNewsletterCreateInput>;
};

export type NewsletterCreateInput = {
  aiDefaultPromptHeader?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptObject?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptHeader?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptObject?: InputMaybe<Scalars['String']['input']>;
  /** JSON automation config */
  automationConfig?: InputMaybe<Scalars['String']['input']>;
  /** JSON automation query */
  automationQuery?: InputMaybe<Scalars['String']['input']>;
  /** Store time (at Europe/Paris Timezone) to run automated campaign creation. eg: "10h15" => 1015 */
  automationTime?: InputMaybe<Scalars['Int']['input']>;
  autoValidateXMLCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  available?: InputMaybe<Scalars['String']['input']>;
  brandKey: BrandKey;
  campaignPreHeaderPattern?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Newsletter.campaigns" relation: "Campaign.newsletter"'s inverse relation */
  campaigns?: InputMaybe<NewsletterNestedCampaignsCreateInput>;
  campaignSubjectPattern?: InputMaybe<Scalars['String']['input']>;
  defaultCampaignSectionCount?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  isFromNlf?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Actions for the "Newsletter.newsletterDuplications" relation: "NewsletterDuplication.newsletter"'s inverse relation */
  newsletterDuplications?: InputMaybe<NewsletterNestedNewsletterDuplicationsCreateInput>;
  /** Actions for the "Newsletter.newsletterGenerations" relation: "NewsletterGeneration.newsletter"'s inverse relation */
  newsletterGenerations?: InputMaybe<NewsletterNestedNewsletterGenerationsCreateInput>;
  /** Actions for the "Newsletter.newsletterHistories" relation: "NewsletterHistory.newsletter"'s inverse relation */
  newsletterHistories?: InputMaybe<NewsletterNestedNewsletterHistoriesCreateInput>;
  nlfName?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  rawMedias?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['Date']['input']>;
};

export type NewsletterNestedCampaignsCreateInput = {
  /** Connect existing "Campaign" nodes to the new "Newsletter" node, through the "Newsletter.campaigns" relation. */
  connect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  /** Create new "Campaign" nodes and connect them to the new "Newsletter" node, through the "Newsletter.campaigns" relation. */
  create?: InputMaybe<Array<CampaignWithForcedNewsletterCreateInput>>;
};

export type CampaignWithForcedNewsletterCreateInput = {
  availableAt?: InputMaybe<Scalars['Date']['input']>;
  /** Actions for the "Campaign.campaignHistories" relation: "CampaignHistory.campaign"'s inverse relation */
  campaignHistories?: InputMaybe<CampaignNestedCampaignHistoriesCreateInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
  preHeader?: InputMaybe<Scalars['String']['input']>;
  rawMedias?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Campaign.sections" relation: "Section.campaign"'s inverse relation */
  sections?: InputMaybe<CampaignNestedSectionsCreateInput>;
  subject: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignNestedSectionsCreateInput = {
  /** Connect existing "Section" nodes to the new "Campaign" node, through the "Campaign.sections" relation. */
  connect?: InputMaybe<Array<SectionWhereUniqueInput>>;
  /** Create new "Section" nodes and connect them to the new "Campaign" node, through the "Campaign.sections" relation. */
  create?: InputMaybe<Array<SectionWithForcedCampaignCreateInput>>;
};

export type SectionWithForcedCampaignCreateInput = {
  /** Actions for the "Section.blocks" relation: "Block.section"'s inverse relation */
  blocks?: InputMaybe<SectionNestedBlocksCreateInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterNestedNewsletterDuplicationsCreateInput = {
  /**
   * Connect existing "NewsletterDuplication" nodes to the new "Newsletter" node,
   * through the "Newsletter.newsletterDuplications" relation.
   */
  connect?: InputMaybe<Array<NewsletterDuplicationWhereUniqueInput>>;
  /**
   * Create new "NewsletterDuplication" nodes and connect them to the new
   * "Newsletter" node, through the "Newsletter.newsletterDuplications" relation.
   */
  create?: InputMaybe<Array<NewsletterDuplicationWithForcedNewsletterCreateInput>>;
};

export type NewsletterDuplicationWithForcedNewsletterCreateInput = {
  duplicationDate?: InputMaybe<Scalars['String']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsletterNestedNewsletterGenerationsCreateInput = {
  /**
   * Connect existing "NewsletterGeneration" nodes to the new "Newsletter" node,
   * through the "Newsletter.newsletterGenerations" relation.
   */
  connect?: InputMaybe<Array<NewsletterGenerationWhereUniqueInput>>;
  /**
   * Create new "NewsletterGeneration" nodes and connect them to the new
   * "Newsletter" node, through the "Newsletter.newsletterGenerations" relation.
   */
  create?: InputMaybe<Array<NewsletterGenerationWithForcedNewsletterCreateInput>>;
};

export type NewsletterGenerationWithForcedNewsletterCreateInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  inError?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterNestedNewsletterHistoriesCreateInput = {
  /**
   * Connect existing "NewsletterHistory" nodes to the new "Newsletter" node,
   * through the "Newsletter.newsletterHistories" relation.
   */
  connect?: InputMaybe<Array<NewsletterHistoryWhereUniqueInput>>;
  /**
   * Create new "NewsletterHistory" nodes and connect them to the new "Newsletter"
   * node, through the "Newsletter.newsletterHistories" relation.
   */
  create?: InputMaybe<Array<NewsletterHistoryWithForcedNewsletterCreateInput>>;
};

export type NewsletterHistoryWithForcedNewsletterCreateInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  migration?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
  userName: Scalars['String']['input'];
};

export type CampaignNestedUpdateNewsletterCreateInput = {
  data: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type NewsletterUpdateInput = {
  aiDefaultPromptHeader?: InputMaybe<Scalars['String']['input']>;
  aiDefaultPromptObject?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptHeader?: InputMaybe<Scalars['String']['input']>;
  aiUserPromptObject?: InputMaybe<Scalars['String']['input']>;
  /** JSON automation config */
  automationConfig?: InputMaybe<Scalars['String']['input']>;
  /** JSON automation query */
  automationQuery?: InputMaybe<Scalars['String']['input']>;
  /** Store time (at Europe/Paris Timezone) to run automated campaign creation. eg: "10h15" => 1015 */
  automationTime?: InputMaybe<Scalars['Int']['input']>;
  autoValidateXMLCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  available?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  campaignPreHeaderPattern?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Newsletter.campaigns" relation: "Campaign.newsletter"'s inverse relation */
  campaigns?: InputMaybe<NewsletterNestedCampaignsUpdateInput>;
  campaignSubjectPattern?: InputMaybe<Scalars['String']['input']>;
  defaultCampaignSectionCount?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  isFromNlf?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Newsletter.newsletterDuplications" relation: "NewsletterDuplication.newsletter"'s inverse relation */
  newsletterDuplications?: InputMaybe<NewsletterNestedNewsletterDuplicationsUpdateInput>;
  /** Actions for the "Newsletter.newsletterGenerations" relation: "NewsletterGeneration.newsletter"'s inverse relation */
  newsletterGenerations?: InputMaybe<NewsletterNestedNewsletterGenerationsUpdateInput>;
  /** Actions for the "Newsletter.newsletterHistories" relation: "NewsletterHistory.newsletter"'s inverse relation */
  newsletterHistories?: InputMaybe<NewsletterNestedNewsletterHistoriesUpdateInput>;
  nlfName?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  rawMedias?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['Date']['input']>;
};

export type NewsletterNestedCampaignsUpdateInput = {
  /** Connect existing "Campaign" nodes to the existing "Newsletter" node, through the "Newsletter.campaigns" relation. */
  connect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  /**
   * Create new "Campaign" nodes and connect them to the existing "Newsletter"
   * node, through the "Newsletter.campaigns" relation.
   */
  create?: InputMaybe<Array<CampaignWithForcedNewsletterCreateInput>>;
  /** Delete existing "Campaign" nodes from the "Newsletter.campaigns" relation. */
  delete?: InputMaybe<Array<CampaignWithForcedNewsletterWhereUniqueInput>>;
  /** Disconnect existing "Campaign" nodes of the "Newsletter.campaigns" relation. */
  disconnect?: InputMaybe<Array<CampaignWithForcedNewsletterWhereUniqueInput>>;
  /**
   * Update existing "Campaign" nodes and connect them to the existing "Newsletter"
   * node, through the "Newsletter.campaigns" relation.
   */
  update?: InputMaybe<Array<NewsletterNestedUpdateCampaignsUpdateInput>>;
  /**
   * Upsert existing "Campaign" nodes and connect them to the existing "Newsletter"
   * node, through the "Newsletter.campaigns" relation.
   */
  upsert?: InputMaybe<Array<NewsletterNestedUpsertCampaignsUpdateInput>>;
};

/** Given a forced "newsletter", identifies exactly one "Campaign" node. */
export type CampaignWithForcedNewsletterWhereUniqueInput = {
  availableAt: Scalars['Date']['input'];
};

export type NewsletterNestedUpdateCampaignsUpdateInput = {
  data: CampaignWithForcedNewsletterUpdateInput;
  where: CampaignWithOptionalNewsletterWhereUniqueInput;
};

export type CampaignWithForcedNewsletterUpdateInput = {
  availableAt?: InputMaybe<Scalars['Date']['input']>;
  /** Actions for the "Campaign.campaignHistories" relation: "CampaignHistory.campaign"'s inverse relation */
  campaignHistories?: InputMaybe<CampaignNestedCampaignHistoriesUpdateInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
  preHeader?: InputMaybe<Scalars['String']['input']>;
  rawMedias?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Campaign.sections" relation: "Section.campaign"'s inverse relation */
  sections?: InputMaybe<CampaignNestedSectionsUpdateInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignNestedCampaignHistoriesUpdateInput = {
  /**
   * Connect existing "CampaignHistory" nodes to the existing "Campaign" node,
   * through the "Campaign.campaignHistories" relation.
   */
  connect?: InputMaybe<Array<CampaignHistoryWhereUniqueInput>>;
  /**
   * Create new "CampaignHistory" nodes and connect them to the existing "Campaign"
   * node, through the "Campaign.campaignHistories" relation.
   */
  create?: InputMaybe<Array<CampaignHistoryWithForcedCampaignCreateInput>>;
  /** Delete existing "CampaignHistory" nodes from the "Campaign.campaignHistories" relation. */
  delete?: InputMaybe<Array<CampaignHistoryWhereUniqueInput>>;
  /**
   * Update existing "CampaignHistory" nodes and connect them to the existing
   * "Campaign" node, through the "Campaign.campaignHistories" relation.
   */
  update?: InputMaybe<Array<CampaignNestedUpdateCampaignHistoriesUpdateInput>>;
  /**
   * Upsert existing "CampaignHistory" nodes and connect them to the existing
   * "Campaign" node, through the "Campaign.campaignHistories" relation.
   */
  upsert?: InputMaybe<Array<CampaignNestedUpsertCampaignHistoriesUpdateInput>>;
};

export type CampaignNestedUpdateCampaignHistoriesUpdateInput = {
  data: CampaignHistoryWithForcedCampaignUpdateInput;
  where: CampaignHistoryWhereUniqueInput;
};

export type CampaignHistoryWithForcedCampaignUpdateInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignNestedUpsertCampaignHistoriesUpdateInput = {
  create: CampaignHistoryWithForcedCampaignCreateInput;
  update: CampaignHistoryWithForcedCampaignUpdateInput;
  where: CampaignHistoryWhereUniqueInput;
};

export type CampaignNestedSectionsUpdateInput = {
  /** Connect existing "Section" nodes to the existing "Campaign" node, through the "Campaign.sections" relation. */
  connect?: InputMaybe<Array<SectionWhereUniqueInput>>;
  /** Create new "Section" nodes and connect them to the existing "Campaign" node, through the "Campaign.sections" relation. */
  create?: InputMaybe<Array<SectionWithForcedCampaignCreateInput>>;
  /** Delete existing "Section" nodes from the "Campaign.sections" relation. */
  delete?: InputMaybe<Array<SectionWhereUniqueInput>>;
  /**
   * Update existing "Section" nodes and connect them to the existing "Campaign"
   * node, through the "Campaign.sections" relation.
   */
  update?: InputMaybe<Array<CampaignNestedUpdateSectionsUpdateInput>>;
  /**
   * Upsert existing "Section" nodes and connect them to the existing "Campaign"
   * node, through the "Campaign.sections" relation.
   */
  upsert?: InputMaybe<Array<CampaignNestedUpsertSectionsUpdateInput>>;
};

export type CampaignNestedUpdateSectionsUpdateInput = {
  data: SectionWithForcedCampaignUpdateInput;
  where: SectionWhereUniqueInput;
};

export type SectionWithForcedCampaignUpdateInput = {
  /** Actions for the "Section.blocks" relation: "Block.section"'s inverse relation */
  blocks?: InputMaybe<SectionNestedBlocksUpdateInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SectionNestedBlocksUpdateInput = {
  /** Connect existing "Block" nodes to the existing "Section" node, through the "Section.blocks" relation. */
  connect?: InputMaybe<Array<BlockWhereUniqueInput>>;
  /** Create new "Block" nodes and connect them to the existing "Section" node, through the "Section.blocks" relation. */
  create?: InputMaybe<Array<BlockWithForcedSectionCreateInput>>;
  /** Delete existing "Block" nodes from the "Section.blocks" relation. */
  delete?: InputMaybe<Array<BlockWhereUniqueInput>>;
  /** Disconnect existing "Block" nodes of the "Section.blocks" relation. */
  disconnect?: InputMaybe<Array<BlockWhereUniqueInput>>;
  /** Update existing "Block" nodes and connect them to the existing "Section" node, through the "Section.blocks" relation. */
  update?: InputMaybe<Array<SectionNestedUpdateBlocksUpdateInput>>;
  /** Upsert existing "Block" nodes and connect them to the existing "Section" node, through the "Section.blocks" relation. */
  upsert?: InputMaybe<Array<SectionNestedUpsertBlocksUpdateInput>>;
};

export type SectionNestedUpdateBlocksUpdateInput = {
  data: BlockWithForcedSectionUpdateInput;
  where: BlockWhereUniqueInput;
};

export type BlockWithForcedSectionUpdateInput = {
  /** The article ID */
  articleId?: InputMaybe<Scalars['ID']['input']>;
  blockType?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Is the block automated */
  isAutomated?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoPromo?: InputMaybe<Scalars['Boolean']['input']>;
  leadIn?: InputMaybe<Scalars['Boolean']['input']>;
  linkLabel?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  rawMedia?: InputMaybe<Scalars['String']['input']>;
  surTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SectionNestedUpsertBlocksUpdateInput = {
  create: BlockWithForcedSectionCreateInput;
  update: BlockWithForcedSectionUpdateInput;
  where: BlockWhereUniqueInput;
};

export type CampaignNestedUpsertSectionsUpdateInput = {
  create: SectionWithForcedCampaignCreateInput;
  update: SectionWithForcedCampaignUpdateInput;
  where: SectionWhereUniqueInput;
};

/**
 * Given a known "newsletter", identifies exactly one "Campaign" node with one of these unique combinations of values:
 * - _id
 * - id
 * - availableAt, newsletter (optional)
 */
export type CampaignWithOptionalNewsletterWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  availableAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  newsletter?: InputMaybe<NewsletterWhereUniqueInput>;
};

export type NewsletterNestedUpsertCampaignsUpdateInput = {
  create: CampaignWithForcedNewsletterCreateInput;
  update: CampaignWithForcedNewsletterUpdateInput;
  where: CampaignWithOptionalNewsletterWhereUniqueInput;
};

export type NewsletterNestedNewsletterDuplicationsUpdateInput = {
  /**
   * Connect existing "NewsletterDuplication" nodes to the existing "Newsletter"
   * node, through the "Newsletter.newsletterDuplications" relation.
   */
  connect?: InputMaybe<Array<NewsletterDuplicationWhereUniqueInput>>;
  /**
   * Create new "NewsletterDuplication" nodes and connect them to the existing
   * "Newsletter" node, through the "Newsletter.newsletterDuplications" relation.
   */
  create?: InputMaybe<Array<NewsletterDuplicationWithForcedNewsletterCreateInput>>;
  /** Delete existing "NewsletterDuplication" nodes from the "Newsletter.newsletterDuplications" relation. */
  delete?: InputMaybe<Array<NewsletterDuplicationWhereUniqueInput>>;
  /** Disconnect existing "NewsletterDuplication" nodes of the "Newsletter.newsletterDuplications" relation. */
  disconnect?: InputMaybe<Array<NewsletterDuplicationWhereUniqueInput>>;
  /**
   * Update existing "NewsletterDuplication" nodes and connect them to the existing
   * "Newsletter" node, through the "Newsletter.newsletterDuplications" relation.
   */
  update?: InputMaybe<Array<NewsletterNestedUpdateNewsletterDuplicationsUpdateInput>>;
  /**
   * Upsert existing "NewsletterDuplication" nodes and connect them to the existing
   * "Newsletter" node, through the "Newsletter.newsletterDuplications" relation.
   */
  upsert?: InputMaybe<Array<NewsletterNestedUpsertNewsletterDuplicationsUpdateInput>>;
};

export type NewsletterNestedUpdateNewsletterDuplicationsUpdateInput = {
  data: NewsletterDuplicationWithForcedNewsletterUpdateInput;
  where: NewsletterDuplicationWhereUniqueInput;
};

export type NewsletterDuplicationWithForcedNewsletterUpdateInput = {
  duplicationDate?: InputMaybe<Scalars['String']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsletterNestedUpsertNewsletterDuplicationsUpdateInput = {
  create: NewsletterDuplicationWithForcedNewsletterCreateInput;
  update: NewsletterDuplicationWithForcedNewsletterUpdateInput;
  where: NewsletterDuplicationWhereUniqueInput;
};

export type NewsletterNestedNewsletterGenerationsUpdateInput = {
  /**
   * Connect existing "NewsletterGeneration" nodes to the existing "Newsletter"
   * node, through the "Newsletter.newsletterGenerations" relation.
   */
  connect?: InputMaybe<Array<NewsletterGenerationWhereUniqueInput>>;
  /**
   * Create new "NewsletterGeneration" nodes and connect them to the existing
   * "Newsletter" node, through the "Newsletter.newsletterGenerations" relation.
   */
  create?: InputMaybe<Array<NewsletterGenerationWithForcedNewsletterCreateInput>>;
  /** Delete existing "NewsletterGeneration" nodes from the "Newsletter.newsletterGenerations" relation. */
  delete?: InputMaybe<Array<NewsletterGenerationWhereUniqueInput>>;
  /** Disconnect existing "NewsletterGeneration" nodes of the "Newsletter.newsletterGenerations" relation. */
  disconnect?: InputMaybe<Array<NewsletterGenerationWhereUniqueInput>>;
  /**
   * Update existing "NewsletterGeneration" nodes and connect them to the existing
   * "Newsletter" node, through the "Newsletter.newsletterGenerations" relation.
   */
  update?: InputMaybe<Array<NewsletterNestedUpdateNewsletterGenerationsUpdateInput>>;
  /**
   * Upsert existing "NewsletterGeneration" nodes and connect them to the existing
   * "Newsletter" node, through the "Newsletter.newsletterGenerations" relation.
   */
  upsert?: InputMaybe<Array<NewsletterNestedUpsertNewsletterGenerationsUpdateInput>>;
};

export type NewsletterNestedUpdateNewsletterGenerationsUpdateInput = {
  data: NewsletterGenerationWithForcedNewsletterUpdateInput;
  where: NewsletterGenerationWhereUniqueInput;
};

export type NewsletterGenerationWithForcedNewsletterUpdateInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  inError?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterNestedUpsertNewsletterGenerationsUpdateInput = {
  create: NewsletterGenerationWithForcedNewsletterCreateInput;
  update: NewsletterGenerationWithForcedNewsletterUpdateInput;
  where: NewsletterGenerationWhereUniqueInput;
};

export type NewsletterNestedNewsletterHistoriesUpdateInput = {
  /**
   * Connect existing "NewsletterHistory" nodes to the existing "Newsletter" node,
   * through the "Newsletter.newsletterHistories" relation.
   */
  connect?: InputMaybe<Array<NewsletterHistoryWhereUniqueInput>>;
  /**
   * Create new "NewsletterHistory" nodes and connect them to the existing
   * "Newsletter" node, through the "Newsletter.newsletterHistories" relation.
   */
  create?: InputMaybe<Array<NewsletterHistoryWithForcedNewsletterCreateInput>>;
  /** Delete existing "NewsletterHistory" nodes from the "Newsletter.newsletterHistories" relation. */
  delete?: InputMaybe<Array<NewsletterHistoryWhereUniqueInput>>;
  /** Disconnect existing "NewsletterHistory" nodes of the "Newsletter.newsletterHistories" relation. */
  disconnect?: InputMaybe<Array<NewsletterHistoryWhereUniqueInput>>;
  /**
   * Update existing "NewsletterHistory" nodes and connect them to the existing
   * "Newsletter" node, through the "Newsletter.newsletterHistories" relation.
   */
  update?: InputMaybe<Array<NewsletterNestedUpdateNewsletterHistoriesUpdateInput>>;
  /**
   * Upsert existing "NewsletterHistory" nodes and connect them to the existing
   * "Newsletter" node, through the "Newsletter.newsletterHistories" relation.
   */
  upsert?: InputMaybe<Array<NewsletterNestedUpsertNewsletterHistoriesUpdateInput>>;
};

export type NewsletterNestedUpdateNewsletterHistoriesUpdateInput = {
  data: NewsletterHistoryWithForcedNewsletterUpdateInput;
  where: NewsletterHistoryWhereUniqueInput;
};

export type NewsletterHistoryWithForcedNewsletterUpdateInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  migration?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterNestedUpsertNewsletterHistoriesUpdateInput = {
  create: NewsletterHistoryWithForcedNewsletterCreateInput;
  update: NewsletterHistoryWithForcedNewsletterUpdateInput;
  where: NewsletterHistoryWhereUniqueInput;
};

export type CampaignNestedUpsertNewsletterCreateInput = {
  create: NewsletterCreateInput;
  update: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type SectionNestedUpdateCampaignCreateInput = {
  data: CampaignUpdateInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignUpdateInput = {
  availableAt?: InputMaybe<Scalars['Date']['input']>;
  /** Actions for the "Campaign.campaignHistories" relation: "CampaignHistory.campaign"'s inverse relation */
  campaignHistories?: InputMaybe<CampaignNestedCampaignHistoriesUpdateInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "Campaign.newsletter" relation */
  newsletter?: InputMaybe<CampaignNestedNewsletterUpdateInput>;
  preHeader?: InputMaybe<Scalars['String']['input']>;
  rawMedias?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Campaign.sections" relation: "Section.campaign"'s inverse relation */
  sections?: InputMaybe<CampaignNestedSectionsUpdateInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignNestedNewsletterUpdateInput = {
  /** Connect an existing "Newsletter" node to the existing "Campaign" node, through the "Campaign.newsletter" relation. */
  connect?: InputMaybe<NewsletterWhereUniqueInput>;
  /** Create a new "Newsletter" node and connect it to the existing "Campaign" node, through the "Campaign.newsletter" relation. */
  create?: InputMaybe<NewsletterCreateInput>;
  /** Disconnect the current connected "Newsletter" node, if any, of the "Campaign.newsletter" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Update an existing "Newsletter" node and connect it to the existing "Campaign"
   * node, through the "Campaign.newsletter" relation.
   */
  update?: InputMaybe<CampaignNestedUpdateNewsletterUpdateInput>;
  /**
   * Create or update a "Newsletter" node and connect it to the existing "Campaign"
   * node, through the "Campaign.newsletter" relation.
   */
  upsert?: InputMaybe<CampaignNestedUpsertNewsletterUpdateInput>;
};

export type CampaignNestedUpdateNewsletterUpdateInput = {
  data: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type CampaignNestedUpsertNewsletterUpdateInput = {
  create: NewsletterCreateInput;
  update: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type SectionNestedUpsertCampaignCreateInput = {
  create: CampaignCreateInput;
  update: CampaignUpdateInput;
  where: CampaignWhereUniqueInput;
};

export type BlockNestedUpdateSectionCreateInput = {
  data: SectionUpdateInput;
  where: SectionWhereUniqueInput;
};

export type SectionUpdateInput = {
  /** Actions for the "Section.blocks" relation: "Block.section"'s inverse relation */
  blocks?: InputMaybe<SectionNestedBlocksUpdateInput>;
  /** Actions for the "Section.campaign" relation */
  campaign?: InputMaybe<SectionNestedCampaignUpdateInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SectionNestedCampaignUpdateInput = {
  /** Connect an existing "Campaign" node to the existing "Section" node, through the "Section.campaign" relation. */
  connect?: InputMaybe<CampaignWhereUniqueInput>;
  /** Create a new "Campaign" node and connect it to the existing "Section" node, through the "Section.campaign" relation. */
  create?: InputMaybe<CampaignCreateInput>;
  /** Update an existing "Campaign" node and connect it to the existing "Section" node, through the "Section.campaign" relation. */
  update?: InputMaybe<SectionNestedUpdateCampaignUpdateInput>;
  /** Create or update a "Campaign" node and connect it to the existing "Section" node, through the "Section.campaign" relation. */
  upsert?: InputMaybe<SectionNestedUpsertCampaignUpdateInput>;
};

export type SectionNestedUpdateCampaignUpdateInput = {
  data: CampaignUpdateInput;
  where: CampaignWhereUniqueInput;
};

export type SectionNestedUpsertCampaignUpdateInput = {
  create: CampaignCreateInput;
  update: CampaignUpdateInput;
  where: CampaignWhereUniqueInput;
};

export type BlockNestedUpsertSectionCreateInput = {
  create: SectionCreateInput;
  update: SectionUpdateInput;
  where: SectionWhereUniqueInput;
};

export type CampaignHistoryCreateInput = {
  /** Actions for the "CampaignHistory.campaign" relation */
  campaign: CampaignHistoryNestedCampaignCreateInput;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
  userName: Scalars['String']['input'];
};

export type CampaignHistoryNestedCampaignCreateInput = {
  /** Connect an existing "Campaign" node to the new "CampaignHistory" node, through the "CampaignHistory.campaign" relation. */
  connect?: InputMaybe<CampaignWhereUniqueInput>;
  /**
   * Create a new "Campaign" node and connect it to the new "CampaignHistory" node,
   * through the "CampaignHistory.campaign" relation.
   */
  create?: InputMaybe<CampaignCreateInput>;
  /**
   * Update an existing "Campaign" node and connect it to the new "CampaignHistory"
   * node, through the "CampaignHistory.campaign" relation.
   */
  update?: InputMaybe<CampaignHistoryNestedUpdateCampaignCreateInput>;
  /**
   * Create or update a "Campaign" node and connect it to the new "CampaignHistory"
   * node, through the "CampaignHistory.campaign" relation.
   */
  upsert?: InputMaybe<CampaignHistoryNestedUpsertCampaignCreateInput>;
};

export type CampaignHistoryNestedUpdateCampaignCreateInput = {
  data: CampaignUpdateInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignHistoryNestedUpsertCampaignCreateInput = {
  create: CampaignCreateInput;
  update: CampaignUpdateInput;
  where: CampaignWhereUniqueInput;
};

export type FlashSenderHistoryCreateInput = {
  brandKey: BrandKey;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  link: Scalars['String']['input'];
  resource: ContentType;
  response?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  user: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type NewsletterDuplicationCreateInput = {
  duplicationDate?: InputMaybe<Scalars['String']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "NewsletterDuplication.newsletter" relation */
  newsletter?: InputMaybe<NewsletterDuplicationNestedNewsletterCreateInput>;
  target?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsletterDuplicationNestedNewsletterCreateInput = {
  /**
   * Connect an existing "Newsletter" node to the new "NewsletterDuplication" node,
   * through the "NewsletterDuplication.newsletter" relation.
   */
  connect?: InputMaybe<NewsletterWhereUniqueInput>;
  /**
   * Create a new "Newsletter" node and connect it to the new
   * "NewsletterDuplication" node, through the "NewsletterDuplication.newsletter" relation.
   */
  create?: InputMaybe<NewsletterCreateInput>;
  /**
   * Update an existing "Newsletter" node and connect it to the new
   * "NewsletterDuplication" node, through the "NewsletterDuplication.newsletter" relation.
   */
  update?: InputMaybe<NewsletterDuplicationNestedUpdateNewsletterCreateInput>;
  /**
   * Create or update a "Newsletter" node and connect it to the new
   * "NewsletterDuplication" node, through the "NewsletterDuplication.newsletter" relation.
   */
  upsert?: InputMaybe<NewsletterDuplicationNestedUpsertNewsletterCreateInput>;
};

export type NewsletterDuplicationNestedUpdateNewsletterCreateInput = {
  data: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type NewsletterDuplicationNestedUpsertNewsletterCreateInput = {
  create: NewsletterCreateInput;
  update: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type NewsletterGenerationCreateInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  inError?: InputMaybe<Scalars['Boolean']['input']>;
  /** Actions for the "NewsletterGeneration.newsletter" relation */
  newsletter?: InputMaybe<NewsletterGenerationNestedNewsletterCreateInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterGenerationNestedNewsletterCreateInput = {
  /**
   * Connect an existing "Newsletter" node to the new "NewsletterGeneration" node,
   * through the "NewsletterGeneration.newsletter" relation.
   */
  connect?: InputMaybe<NewsletterWhereUniqueInput>;
  /**
   * Create a new "Newsletter" node and connect it to the new
   * "NewsletterGeneration" node, through the "NewsletterGeneration.newsletter" relation.
   */
  create?: InputMaybe<NewsletterCreateInput>;
  /**
   * Update an existing "Newsletter" node and connect it to the new
   * "NewsletterGeneration" node, through the "NewsletterGeneration.newsletter" relation.
   */
  update?: InputMaybe<NewsletterGenerationNestedUpdateNewsletterCreateInput>;
  /**
   * Create or update a "Newsletter" node and connect it to the new
   * "NewsletterGeneration" node, through the "NewsletterGeneration.newsletter" relation.
   */
  upsert?: InputMaybe<NewsletterGenerationNestedUpsertNewsletterCreateInput>;
};

export type NewsletterGenerationNestedUpdateNewsletterCreateInput = {
  data: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type NewsletterGenerationNestedUpsertNewsletterCreateInput = {
  create: NewsletterCreateInput;
  update: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type NewsletterHistoryCreateInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  migration?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "NewsletterHistory.newsletter" relation */
  newsletter?: InputMaybe<NewsletterHistoryNestedNewsletterCreateInput>;
  userId: Scalars['ID']['input'];
  userName: Scalars['String']['input'];
};

export type NewsletterHistoryNestedNewsletterCreateInput = {
  /**
   * Connect an existing "Newsletter" node to the new "NewsletterHistory" node,
   * through the "NewsletterHistory.newsletter" relation.
   */
  connect?: InputMaybe<NewsletterWhereUniqueInput>;
  /**
   * Create a new "Newsletter" node and connect it to the new "NewsletterHistory"
   * node, through the "NewsletterHistory.newsletter" relation.
   */
  create?: InputMaybe<NewsletterCreateInput>;
  /**
   * Update an existing "Newsletter" node and connect it to the new
   * "NewsletterHistory" node, through the "NewsletterHistory.newsletter" relation.
   */
  update?: InputMaybe<NewsletterHistoryNestedUpdateNewsletterCreateInput>;
  /**
   * Create or update a "Newsletter" node and connect it to the new
   * "NewsletterHistory" node, through the "NewsletterHistory.newsletter" relation.
   */
  upsert?: InputMaybe<NewsletterHistoryNestedUpsertNewsletterCreateInput>;
};

export type NewsletterHistoryNestedUpdateNewsletterCreateInput = {
  data: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type NewsletterHistoryNestedUpsertNewsletterCreateInput = {
  create: NewsletterCreateInput;
  update: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type BlockUpdateInput = {
  /** The article ID */
  articleId?: InputMaybe<Scalars['ID']['input']>;
  blockType?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Is the block automated */
  isAutomated?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoPromo?: InputMaybe<Scalars['Boolean']['input']>;
  leadIn?: InputMaybe<Scalars['Boolean']['input']>;
  linkLabel?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  rawMedia?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Block.section" relation */
  section?: InputMaybe<BlockNestedSectionUpdateInput>;
  surTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type BlockNestedSectionUpdateInput = {
  /** Connect an existing "Section" node to the existing "Block" node, through the "Block.section" relation. */
  connect?: InputMaybe<SectionWhereUniqueInput>;
  /** Create a new "Section" node and connect it to the existing "Block" node, through the "Block.section" relation. */
  create?: InputMaybe<SectionCreateInput>;
  /** Disconnect the current connected "Section" node, if any, of the "Block.section" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Section" node and connect it to the existing "Block" node, through the "Block.section" relation. */
  update?: InputMaybe<BlockNestedUpdateSectionUpdateInput>;
  /** Create or update a "Section" node and connect it to the existing "Block" node, through the "Block.section" relation. */
  upsert?: InputMaybe<BlockNestedUpsertSectionUpdateInput>;
};

export type BlockNestedUpdateSectionUpdateInput = {
  data: SectionUpdateInput;
  where: SectionWhereUniqueInput;
};

export type BlockNestedUpsertSectionUpdateInput = {
  create: SectionCreateInput;
  update: SectionUpdateInput;
  where: SectionWhereUniqueInput;
};

export type CampaignHistoryUpdateInput = {
  /** Actions for the "CampaignHistory.campaign" relation */
  campaign?: InputMaybe<CampaignHistoryNestedCampaignUpdateInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignHistoryNestedCampaignUpdateInput = {
  /**
   * Connect an existing "Campaign" node to the existing "CampaignHistory" node,
   * through the "CampaignHistory.campaign" relation.
   */
  connect?: InputMaybe<CampaignWhereUniqueInput>;
  /**
   * Create a new "Campaign" node and connect it to the existing "CampaignHistory"
   * node, through the "CampaignHistory.campaign" relation.
   */
  create?: InputMaybe<CampaignCreateInput>;
  /**
   * Update an existing "Campaign" node and connect it to the existing
   * "CampaignHistory" node, through the "CampaignHistory.campaign" relation.
   */
  update?: InputMaybe<CampaignHistoryNestedUpdateCampaignUpdateInput>;
  /**
   * Create or update a "Campaign" node and connect it to the existing
   * "CampaignHistory" node, through the "CampaignHistory.campaign" relation.
   */
  upsert?: InputMaybe<CampaignHistoryNestedUpsertCampaignUpdateInput>;
};

export type CampaignHistoryNestedUpdateCampaignUpdateInput = {
  data: CampaignUpdateInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignHistoryNestedUpsertCampaignUpdateInput = {
  create: CampaignCreateInput;
  update: CampaignUpdateInput;
  where: CampaignWhereUniqueInput;
};

export type FlashSenderHistoryUpdateInput = {
  brandKey?: InputMaybe<BrandKey>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<ContentType>;
  response?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterDuplicationUpdateInput = {
  duplicationDate?: InputMaybe<Scalars['String']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "NewsletterDuplication.newsletter" relation */
  newsletter?: InputMaybe<NewsletterDuplicationNestedNewsletterUpdateInput>;
  target?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsletterDuplicationNestedNewsletterUpdateInput = {
  /**
   * Connect an existing "Newsletter" node to the existing "NewsletterDuplication"
   * node, through the "NewsletterDuplication.newsletter" relation.
   */
  connect?: InputMaybe<NewsletterWhereUniqueInput>;
  /**
   * Create a new "Newsletter" node and connect it to the existing
   * "NewsletterDuplication" node, through the "NewsletterDuplication.newsletter" relation.
   */
  create?: InputMaybe<NewsletterCreateInput>;
  /** Disconnect the current connected "Newsletter" node, if any, of the "NewsletterDuplication.newsletter" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Update an existing "Newsletter" node and connect it to the existing
   * "NewsletterDuplication" node, through the "NewsletterDuplication.newsletter" relation.
   */
  update?: InputMaybe<NewsletterDuplicationNestedUpdateNewsletterUpdateInput>;
  /**
   * Create or update a "Newsletter" node and connect it to the existing
   * "NewsletterDuplication" node, through the "NewsletterDuplication.newsletter" relation.
   */
  upsert?: InputMaybe<NewsletterDuplicationNestedUpsertNewsletterUpdateInput>;
};

export type NewsletterDuplicationNestedUpdateNewsletterUpdateInput = {
  data: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type NewsletterDuplicationNestedUpsertNewsletterUpdateInput = {
  create: NewsletterCreateInput;
  update: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type NewsletterGenerationUpdateInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  inError?: InputMaybe<Scalars['Boolean']['input']>;
  /** Actions for the "NewsletterGeneration.newsletter" relation */
  newsletter?: InputMaybe<NewsletterGenerationNestedNewsletterUpdateInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterGenerationNestedNewsletterUpdateInput = {
  /**
   * Connect an existing "Newsletter" node to the existing "NewsletterGeneration"
   * node, through the "NewsletterGeneration.newsletter" relation.
   */
  connect?: InputMaybe<NewsletterWhereUniqueInput>;
  /**
   * Create a new "Newsletter" node and connect it to the existing
   * "NewsletterGeneration" node, through the "NewsletterGeneration.newsletter" relation.
   */
  create?: InputMaybe<NewsletterCreateInput>;
  /** Disconnect the current connected "Newsletter" node, if any, of the "NewsletterGeneration.newsletter" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Update an existing "Newsletter" node and connect it to the existing
   * "NewsletterGeneration" node, through the "NewsletterGeneration.newsletter" relation.
   */
  update?: InputMaybe<NewsletterGenerationNestedUpdateNewsletterUpdateInput>;
  /**
   * Create or update a "Newsletter" node and connect it to the existing
   * "NewsletterGeneration" node, through the "NewsletterGeneration.newsletter" relation.
   */
  upsert?: InputMaybe<NewsletterGenerationNestedUpsertNewsletterUpdateInput>;
};

export type NewsletterGenerationNestedUpdateNewsletterUpdateInput = {
  data: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type NewsletterGenerationNestedUpsertNewsletterUpdateInput = {
  create: NewsletterCreateInput;
  update: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type NewsletterHistoryUpdateInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  migration?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "NewsletterHistory.newsletter" relation */
  newsletter?: InputMaybe<NewsletterHistoryNestedNewsletterUpdateInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterHistoryNestedNewsletterUpdateInput = {
  /**
   * Connect an existing "Newsletter" node to the existing "NewsletterHistory"
   * node, through the "NewsletterHistory.newsletter" relation.
   */
  connect?: InputMaybe<NewsletterWhereUniqueInput>;
  /**
   * Create a new "Newsletter" node and connect it to the existing
   * "NewsletterHistory" node, through the "NewsletterHistory.newsletter" relation.
   */
  create?: InputMaybe<NewsletterCreateInput>;
  /** Disconnect the current connected "Newsletter" node, if any, of the "NewsletterHistory.newsletter" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Update an existing "Newsletter" node and connect it to the existing
   * "NewsletterHistory" node, through the "NewsletterHistory.newsletter" relation.
   */
  update?: InputMaybe<NewsletterHistoryNestedUpdateNewsletterUpdateInput>;
  /**
   * Create or update a "Newsletter" node and connect it to the existing
   * "NewsletterHistory" node, through the "NewsletterHistory.newsletter" relation.
   */
  upsert?: InputMaybe<NewsletterHistoryNestedUpsertNewsletterUpdateInput>;
};

export type NewsletterHistoryNestedUpdateNewsletterUpdateInput = {
  data: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type NewsletterHistoryNestedUpsertNewsletterUpdateInput = {
  create: NewsletterCreateInput;
  update: NewsletterUpdateInput;
  where: NewsletterWhereUniqueInput;
};

export type SendNlFlashMutation_Mutation = {
  __typename?: 'Mutation',
  sendNlFlash?: string | null
};


export type SendNlFlashMutationVariables = Exact<{
  brandKey: BrandKey;
  subject: Scalars['String']['input'];
  teaser: Scalars['String']['input'];
  img: Scalars['String']['input'];
  imgAlt: Scalars['String']['input'];
  title: Scalars['String']['input'];
  contentUrl: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
  resource: ContentType;
}>;


export type SendNlFlashMutation = SendNlFlashMutation_Mutation;

export type GetFlashSenderHistoriesQuery_flashSenderHistories_FlashSenderHistory = {
  __typename?: 'FlashSenderHistory',
  id: string,
  createdAt: string
};

export type GetFlashSenderHistoriesQuery_Query = {
  __typename?: 'Query',
  flashSenderHistories: Array<GetFlashSenderHistoriesQuery_flashSenderHistories_FlashSenderHistory>
};


export type GetFlashSenderHistoriesQueryVariables = Exact<{
  where?: InputMaybe<FlashSenderHistoryWhereInput>;
  orderBy?: InputMaybe<Array<FlashSenderHistoryOrderByInput> | FlashSenderHistoryOrderByInput>;
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFlashSenderHistoriesQuery = GetFlashSenderHistoriesQuery_Query;


export const SendNlFlashDocument = gql`
    mutation SendNLFlash($brandKey: BrandKey!, $subject: String!, $teaser: String!, $img: String!, $imgAlt: String!, $title: String!, $contentUrl: String!, $uuid: String!, $resource: ContentType!) {
  sendNlFlash(brandKey: $brandKey, subject: $subject, teaser: $teaser, img: $img, imgAlt: $imgAlt, title: $title, contentUrl: $contentUrl, uuid: $uuid, resource: $resource)
}
    `;
export type SendNlFlashMutationFn = Apollo.MutationFunction<SendNlFlashMutation, SendNlFlashMutationVariables>;

/**
 * __useSendNlFlashMutation__
 *
 * To run a mutation, you first call `useSendNlFlashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNlFlashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNlFlashMutation, { data, loading, error }] = useSendNlFlashMutation({
 *   variables: {
 *      brandKey: // value for 'brandKey'
 *      subject: // value for 'subject'
 *      teaser: // value for 'teaser'
 *      img: // value for 'img'
 *      imgAlt: // value for 'imgAlt'
 *      title: // value for 'title'
 *      contentUrl: // value for 'contentUrl'
 *      uuid: // value for 'uuid'
 *      resource: // value for 'resource'
 *   },
 * });
 */
export function useSendNlFlashMutation(baseOptions?: Apollo.MutationHookOptions<SendNlFlashMutation, SendNlFlashMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendNlFlashMutation, SendNlFlashMutationVariables>(SendNlFlashDocument, options);
      }
export type SendNlFlashMutationHookResult = ReturnType<typeof useSendNlFlashMutation>;
export type SendNlFlashMutationResult = Apollo.MutationResult<SendNlFlashMutation>;
export type SendNlFlashMutationOptions = Apollo.BaseMutationOptions<SendNlFlashMutation, SendNlFlashMutationVariables>;
export const GetFlashSenderHistoriesDocument = gql`
    query GetFlashSenderHistories($where: FlashSenderHistoryWhereInput, $orderBy: [FlashSenderHistoryOrderByInput!], $first: Int!, $skip: Int) {
  flashSenderHistories(where: $where, orderBy: $orderBy, first: $first, skip: $skip) {
    id
    createdAt
  }
}
    `;

/**
 * __useGetFlashSenderHistoriesQuery__
 *
 * To run a query within a React component, call `useGetFlashSenderHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlashSenderHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlashSenderHistoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetFlashSenderHistoriesQuery(baseOptions: Apollo.QueryHookOptions<GetFlashSenderHistoriesQuery, GetFlashSenderHistoriesQueryVariables> & ({ variables: GetFlashSenderHistoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFlashSenderHistoriesQuery, GetFlashSenderHistoriesQueryVariables>(GetFlashSenderHistoriesDocument, options);
      }
export function useGetFlashSenderHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFlashSenderHistoriesQuery, GetFlashSenderHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFlashSenderHistoriesQuery, GetFlashSenderHistoriesQueryVariables>(GetFlashSenderHistoriesDocument, options);
        }
export function useGetFlashSenderHistoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFlashSenderHistoriesQuery, GetFlashSenderHistoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFlashSenderHistoriesQuery, GetFlashSenderHistoriesQueryVariables>(GetFlashSenderHistoriesDocument, options);
        }
export type GetFlashSenderHistoriesQueryHookResult = ReturnType<typeof useGetFlashSenderHistoriesQuery>;
export type GetFlashSenderHistoriesLazyQueryHookResult = ReturnType<typeof useGetFlashSenderHistoriesLazyQuery>;
export type GetFlashSenderHistoriesSuspenseQueryHookResult = ReturnType<typeof useGetFlashSenderHistoriesSuspenseQuery>;
export type GetFlashSenderHistoriesQueryResult = Apollo.QueryResult<GetFlashSenderHistoriesQuery, GetFlashSenderHistoriesQueryVariables>;